"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Finance Domain APIs
 * This is the API documentation for the Finance Domain. This domain is responsible for managing all financial transactions for the Mothership platform.
 *
 * The version of the OpenAPI document: 1.23.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerCreditMemoV1ApiAxiosParamCreator = exports.CreditV2LegacyApi = exports.CreditV2LegacyApiFactory = exports.CreditV2LegacyApiFp = exports.CreditV2LegacyApiAxiosParamCreator = exports.CreditLegacyApi = exports.CreditLegacyApiFactory = exports.CreditLegacyApiFp = exports.CreditLegacyApiAxiosParamCreator = exports.ContactLegacyApi = exports.ContactLegacyApiFactory = exports.ContactLegacyApiFp = exports.ContactLegacyApiAxiosParamCreator = exports.CompanyLegacyApi = exports.CompanyLegacyApiFactory = exports.CompanyLegacyApiFp = exports.CompanyLegacyApiAxiosParamCreator = exports.BillsLegacyApi = exports.BillsLegacyApiFactory = exports.BillsLegacyApiFp = exports.BillsLegacyApiAxiosParamCreator = exports.VendorBillStatus = exports.VendorBillCreditType = exports.SubsidiaryCountry = exports.SortOrder = exports.ShipmentPayoutStatus = exports.ShipmentPaymentStatus = exports.ServiceType = exports.PayoutSource = exports.PaymentStatus = exports.PaymentSourceType = exports.PaymentProcessor = exports.LineItemType = exports.ItemType = exports.ItemTransactionType = exports.InvoiceOwnerType = exports.InvoiceDtoStatus = exports.CustomerPaymentSourceType = exports.CustomerPaymentDepositAccount = exports.CustomerInvoiceStatus = exports.CustomerCreditMemoType = exports.CustomerCreditMemoStatus = exports.CreditType = exports.CreditSource = exports.ContactType = exports.ClearingStatus = exports.BillType = exports.BillStatus = exports.BillOwnerType = exports.AccountingEntity = void 0;
exports.PayoutsLegacyApiFactory = exports.PayoutsLegacyApiFp = exports.PayoutsLegacyApiAxiosParamCreator = exports.PaymentsLegacyApi = exports.PaymentsLegacyApiFactory = exports.PaymentsLegacyApiFp = exports.PaymentsLegacyApiAxiosParamCreator = exports.NetSuiteLegacyApi = exports.NetSuiteLegacyApiFactory = exports.NetSuiteLegacyApiFp = exports.NetSuiteLegacyApiAxiosParamCreator = exports.ItemV1Api = exports.ItemV1ApiFactory = exports.ItemV1ApiFp = exports.ItemV1ApiAxiosParamCreator = exports.InvoicesLegacyApi = exports.InvoicesLegacyApiFactory = exports.InvoicesLegacyApiFp = exports.InvoicesLegacyApiAxiosParamCreator = exports.InvoiceLineItemsLegacyApi = exports.InvoiceLineItemsLegacyApiFactory = exports.InvoiceLineItemsLegacyApiFp = exports.InvoiceLineItemsLegacyApiAxiosParamCreator = exports.CustomerV1Api = exports.CustomerV1ApiFactory = exports.CustomerV1ApiFp = exports.CustomerV1ApiAxiosParamCreator = exports.CustomerRefundV1Api = exports.CustomerRefundV1ApiFactory = exports.CustomerRefundV1ApiFp = exports.CustomerRefundV1ApiAxiosParamCreator = exports.CustomerRefundApplicationV1Api = exports.CustomerRefundApplicationV1ApiFactory = exports.CustomerRefundApplicationV1ApiFp = exports.CustomerRefundApplicationV1ApiAxiosParamCreator = exports.CustomerPaymentV1Api = exports.CustomerPaymentV1ApiFactory = exports.CustomerPaymentV1ApiFp = exports.CustomerPaymentV1ApiAxiosParamCreator = exports.CustomerInvoiceV1Api = exports.CustomerInvoiceV1ApiFactory = exports.CustomerInvoiceV1ApiFp = exports.CustomerInvoiceV1ApiAxiosParamCreator = exports.CustomerInvoiceApplicationV1Api = exports.CustomerInvoiceApplicationV1ApiFactory = exports.CustomerInvoiceApplicationV1ApiFp = exports.CustomerInvoiceApplicationV1ApiAxiosParamCreator = exports.CustomerCreditMemoV1Api = exports.CustomerCreditMemoV1ApiFactory = exports.CustomerCreditMemoV1ApiFp = void 0;
exports.VendorV1Api = exports.VendorV1ApiFactory = exports.VendorV1ApiFp = exports.VendorV1ApiAxiosParamCreator = exports.VendorPaymentV1Api = exports.VendorPaymentV1ApiFactory = exports.VendorPaymentV1ApiFp = exports.VendorPaymentV1ApiAxiosParamCreator = exports.VendorBillV1Api = exports.VendorBillV1ApiFactory = exports.VendorBillV1ApiFp = exports.VendorBillV1ApiAxiosParamCreator = exports.VendorBillCreditV1Api = exports.VendorBillCreditV1ApiFactory = exports.VendorBillCreditV1ApiFp = exports.VendorBillCreditV1ApiAxiosParamCreator = exports.VendorBillApplicationV1Api = exports.VendorBillApplicationV1ApiFactory = exports.VendorBillApplicationV1ApiFp = exports.VendorBillApplicationV1ApiAxiosParamCreator = exports.TermV1Api = exports.TermV1ApiFactory = exports.TermV1ApiFp = exports.TermV1ApiAxiosParamCreator = exports.SubsidiaryV1Api = exports.SubsidiaryV1ApiFactory = exports.SubsidiaryV1ApiFp = exports.SubsidiaryV1ApiAxiosParamCreator = exports.ShipmentsLegacyApi = exports.ShipmentsLegacyApiFactory = exports.ShipmentsLegacyApiFp = exports.ShipmentsLegacyApiAxiosParamCreator = exports.ServiceV1Api = exports.ServiceV1ApiFactory = exports.ServiceV1ApiFp = exports.ServiceV1ApiAxiosParamCreator = exports.PayoutsLegacyApi = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
var AccountingEntity;
(function (AccountingEntity) {
    AccountingEntity["Bill"] = "bill";
    AccountingEntity["Contact"] = "contact";
    AccountingEntity["Credit"] = "credit";
    AccountingEntity["Document"] = "document";
    AccountingEntity["Invoice"] = "invoice";
    AccountingEntity["LineItem"] = "lineItem";
    AccountingEntity["Payment"] = "payment";
    AccountingEntity["Payout"] = "payout";
    AccountingEntity["Refund"] = "refund";
    AccountingEntity["Term"] = "term";
    AccountingEntity["VendorCredit"] = "vendorCredit";
    AccountingEntity["CreditsV2"] = "credits_v2";
})(AccountingEntity = exports.AccountingEntity || (exports.AccountingEntity = {}));
/**
 *
 * @export
 * @enum {string}
 */
var BillOwnerType;
(function (BillOwnerType) {
    BillOwnerType["Referral"] = "referral";
    BillOwnerType["Shipment"] = "shipment";
})(BillOwnerType = exports.BillOwnerType || (exports.BillOwnerType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var BillStatus;
(function (BillStatus) {
    BillStatus["Draft"] = "draft";
    BillStatus["Authorized"] = "authorized";
    BillStatus["Paid"] = "paid";
    BillStatus["Processing"] = "processing";
    BillStatus["Voided"] = "voided";
})(BillStatus = exports.BillStatus || (exports.BillStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var BillType;
(function (BillType) {
    BillType["Additional"] = "additional";
    BillType["Adjustment"] = "adjustment";
    BillType["BaseShipment"] = "baseShipment";
    BillType["Coverage"] = "coverage";
    BillType["Surge"] = "surge";
    BillType["Referral"] = "referral";
})(BillType = exports.BillType || (exports.BillType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ClearingStatus;
(function (ClearingStatus) {
    ClearingStatus["Voided"] = "voided";
    ClearingStatus["Failed"] = "failed";
    ClearingStatus["Cancelled"] = "cancelled";
    ClearingStatus["Processing"] = "processing";
    ClearingStatus["Succeeded"] = "succeeded";
})(ClearingStatus = exports.ClearingStatus || (exports.ClearingStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ContactType;
(function (ContactType) {
    ContactType["AccountsPayable"] = "accountsPayable";
    ContactType["AccountsReceivable"] = "accountsReceivable";
    ContactType["BothAccounts"] = "bothAccounts";
})(ContactType = exports.ContactType || (exports.ContactType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CreditSource;
(function (CreditSource) {
    CreditSource["MothershipCredit"] = "mothershipCredit";
    CreditSource["Other"] = "other";
    CreditSource["Promotion"] = "promotion";
})(CreditSource = exports.CreditSource || (exports.CreditSource = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CreditType;
(function (CreditType) {
    CreditType["CreditNoteAllocation"] = "creditNoteAllocation";
    CreditType["Overpayment"] = "overpayment";
    CreditType["Referral"] = "referral";
    CreditType["Refund"] = "refund";
    CreditType["Retention"] = "retention";
    CreditType["Support"] = "support";
    CreditType["Promotional"] = "promotional";
    CreditType["Other"] = "other";
    CreditType["OtherCustomerCredit"] = "otherCustomerCredit";
    CreditType["TermsRefund"] = "termsRefund";
    CreditType["Uncollectible"] = "uncollectible";
})(CreditType = exports.CreditType || (exports.CreditType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CustomerCreditMemoStatus;
(function (CustomerCreditMemoStatus) {
    CustomerCreditMemoStatus["Voided"] = "voided";
})(CustomerCreditMemoStatus = exports.CustomerCreditMemoStatus || (exports.CustomerCreditMemoStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CustomerCreditMemoType;
(function (CustomerCreditMemoType) {
    CustomerCreditMemoType["CreditNoteAllocation"] = "creditNoteAllocation";
    CustomerCreditMemoType["Overpayment"] = "overpayment";
    CustomerCreditMemoType["Referral"] = "referral";
    CustomerCreditMemoType["Refund"] = "refund";
    CustomerCreditMemoType["Support"] = "support";
    CustomerCreditMemoType["Promotional"] = "promotional";
    CustomerCreditMemoType["TermsRefund"] = "termsRefund";
    CustomerCreditMemoType["Other"] = "other";
    CustomerCreditMemoType["OtherCustomerCredit"] = "otherCustomerCredit";
    CustomerCreditMemoType["Uncollectible"] = "uncollectible";
})(CustomerCreditMemoType = exports.CustomerCreditMemoType || (exports.CustomerCreditMemoType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CustomerInvoiceStatus;
(function (CustomerInvoiceStatus) {
    CustomerInvoiceStatus["Draft"] = "draft";
    CustomerInvoiceStatus["Open"] = "open";
    CustomerInvoiceStatus["PartialPayment"] = "partial-payment";
    CustomerInvoiceStatus["PaidInFull"] = "paid-in-full";
    CustomerInvoiceStatus["Voided"] = "voided";
})(CustomerInvoiceStatus = exports.CustomerInvoiceStatus || (exports.CustomerInvoiceStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CustomerPaymentDepositAccount;
(function (CustomerPaymentDepositAccount) {
    CustomerPaymentDepositAccount["Ach"] = "ach";
    CustomerPaymentDepositAccount["AchCreditTransfer"] = "achCreditTransfer";
    CustomerPaymentDepositAccount["Card"] = "card";
    CustomerPaymentDepositAccount["Check"] = "check";
    CustomerPaymentDepositAccount["CustomerSvb2"] = "customerSvb2";
    CustomerPaymentDepositAccount["StripeBalanceCredits"] = "stripeBalanceCredits";
    CustomerPaymentDepositAccount["WellsFargoChecking2649"] = "wellsFargoChecking2649";
    CustomerPaymentDepositAccount["ChaseCheckingCustomerAch5788"] = "chaseCheckingCustomerACH5788";
})(CustomerPaymentDepositAccount = exports.CustomerPaymentDepositAccount || (exports.CustomerPaymentDepositAccount = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CustomerPaymentSourceType;
(function (CustomerPaymentSourceType) {
    CustomerPaymentSourceType["Card"] = "card";
    CustomerPaymentSourceType["Check"] = "check";
    CustomerPaymentSourceType["Ach"] = "ach";
})(CustomerPaymentSourceType = exports.CustomerPaymentSourceType || (exports.CustomerPaymentSourceType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var InvoiceDtoStatus;
(function (InvoiceDtoStatus) {
    InvoiceDtoStatus["Authorised"] = "AUTHORISED";
    InvoiceDtoStatus["Draft"] = "DRAFT";
    InvoiceDtoStatus["Due"] = "DUE";
    InvoiceDtoStatus["Paid"] = "PAID";
    InvoiceDtoStatus["PastDue"] = "PAST_DUE";
    InvoiceDtoStatus["Processing"] = "PROCESSING";
    InvoiceDtoStatus["Voided"] = "VOIDED";
})(InvoiceDtoStatus = exports.InvoiceDtoStatus || (exports.InvoiceDtoStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var InvoiceOwnerType;
(function (InvoiceOwnerType) {
    InvoiceOwnerType["Claim"] = "claim";
    InvoiceOwnerType["Shipment"] = "shipment";
    InvoiceOwnerType["Statement"] = "statement";
})(InvoiceOwnerType = exports.InvoiceOwnerType || (exports.InvoiceOwnerType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ItemTransactionType;
(function (ItemTransactionType) {
    ItemTransactionType["Invoice"] = "invoice";
    ItemTransactionType["Bill"] = "bill";
})(ItemTransactionType = exports.ItemTransactionType || (exports.ItemTransactionType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ItemType;
(function (ItemType) {
    ItemType["InvoiceAdditional"] = "invoice-additional";
    ItemType["InvoiceBaseShipment"] = "invoice-base-shipment";
    ItemType["InvoiceBookingFee"] = "invoice-booking-fee";
    ItemType["InvoiceCancellationFee"] = "invoice-cancellation-fee";
    ItemType["InvoiceClaim"] = "invoice-claim";
    ItemType["InvoiceCreditCardProcessorFee"] = "invoice-credit-card-processor-fee";
    ItemType["InvoiceCrossDock"] = "invoice-cross-dock";
    ItemType["InvoiceFreightCoverage"] = "invoice-freight-coverage";
    ItemType["InvoiceFuelSurcharge"] = "invoice-fuel-surcharge";
    ItemType["InvoiceFbaAppointmentDelivery"] = "invoice-fba-appointment-delivery";
    ItemType["InvoiceHomeDelivery"] = "invoice-home-delivery";
    ItemType["InvoiceLateFee"] = "invoice-late-fee";
    ItemType["InvoiceLocalInsideDelivery"] = "invoice-local-inside-delivery";
    ItemType["InvoiceOversizeFee"] = "invoice-oversize-fee";
    ItemType["InvoiceResidentialDelivery"] = "invoice-residential-delivery";
    ItemType["InvoiceResidentialPickup"] = "invoice-residential-pickup";
    ItemType["InvoiceRevenueShareAdjustment"] = "invoice-revenue-share-adjustment";
    ItemType["InvoiceScheduledDelivery"] = "invoice-scheduled-delivery";
    ItemType["InvoiceScheduledPickup"] = "invoice-scheduled-pickup";
    ItemType["InvoiceTollFee"] = "invoice-toll-fee";
    ItemType["InvoiceTwicCharge"] = "invoice-twic-charge";
    ItemType["InvoiceAppointmentDelivery"] = "invoice-appointment-delivery";
    ItemType["BillBaseShipment"] = "bill-base-shipment";
    ItemType["BillAdditional"] = "bill-additional";
    ItemType["BillAdjustment"] = "bill-adjustment";
    ItemType["BillSurge"] = "bill-surge";
    ItemType["BillFuel"] = "bill-fuel";
    ItemType["BillFreightCoverage"] = "bill-freight-coverage";
    ItemType["BillToll"] = "bill-toll";
    ItemType["BillHomeDelivery"] = "bill-home-delivery";
    ItemType["BillLocalInsideDelivery"] = "bill-local-inside-delivery";
    ItemType["BillTwicCharge"] = "bill-twic-charge";
    ItemType["BillReferral"] = "bill-referral";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LineItemType;
(function (LineItemType) {
    LineItemType["Additional"] = "additional";
    LineItemType["BaseShipment"] = "baseShipment";
    LineItemType["BookingFee"] = "bookingFee";
    LineItemType["CancellationFee"] = "cancellationFee";
    LineItemType["Claim"] = "claim";
    LineItemType["Coverage"] = "coverage";
    LineItemType["CreditCardFee"] = "creditCardFee";
    LineItemType["CrossDock"] = "crossDock";
    LineItemType["FuelSurcharge"] = "fuelSurcharge";
    LineItemType["FbaAppointmentDelivery"] = "fbaAppointmentDelivery";
    LineItemType["HomeDelivery"] = "homeDelivery";
    LineItemType["LateFee"] = "lateFee";
    LineItemType["LocalInsideDelivery"] = "localInsideDelivery";
    LineItemType["OversizeFee"] = "oversizeFee";
    LineItemType["ResidentialDelivery"] = "residentialDelivery";
    LineItemType["ResidentialPickup"] = "residentialPickup";
    LineItemType["RevenueShareAdjustment"] = "revenueShareAdjustment";
    LineItemType["ScheduledDelivery"] = "scheduledDelivery";
    LineItemType["ScheduledPickup"] = "scheduledPickup";
    LineItemType["TollCharge"] = "tollCharge";
    LineItemType["TwicCharge"] = "twicCharge";
    LineItemType["AppointmentDelivery"] = "appointmentDelivery";
})(LineItemType = exports.LineItemType || (exports.LineItemType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PaymentProcessor;
(function (PaymentProcessor) {
    PaymentProcessor["Stripe"] = "Stripe";
    PaymentProcessor["Routable"] = "Routable";
    PaymentProcessor["BillDotCom"] = "BillDotCom";
})(PaymentProcessor = exports.PaymentProcessor || (exports.PaymentProcessor = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PaymentSourceType;
(function (PaymentSourceType) {
    PaymentSourceType["Ach"] = "ach";
    PaymentSourceType["AchCreditTransfer"] = "achCreditTransfer";
    PaymentSourceType["Card"] = "card";
    PaymentSourceType["Check"] = "check";
    PaymentSourceType["CustomerSvb2"] = "customerSvb2";
    PaymentSourceType["StripeBalanceCredits"] = "stripeBalanceCredits";
    PaymentSourceType["WellsFargoChecking2649"] = "wellsFargoChecking2649";
    PaymentSourceType["ChaseCheckingCustomerAch5788"] = "chaseCheckingCustomerACH5788";
})(PaymentSourceType = exports.PaymentSourceType || (exports.PaymentSourceType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Failed"] = "failed";
    PaymentStatus["Pending"] = "pending";
    PaymentStatus["Succeeded"] = "succeeded";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PayoutSource;
(function (PayoutSource) {
    PayoutSource["BillDotCom"] = "billDotCom";
    PayoutSource["Stripe"] = "stripe";
})(PayoutSource = exports.PayoutSource || (exports.PayoutSource = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ServiceType;
(function (ServiceType) {
    ServiceType["Shipment"] = "shipment";
    ServiceType["Claim"] = "claim";
    ServiceType["Statement"] = "statement";
    ServiceType["Referral"] = "referral";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ShipmentPaymentStatus;
(function (ShipmentPaymentStatus) {
    ShipmentPaymentStatus["Invoiced"] = "invoiced";
    ShipmentPaymentStatus["Failed"] = "failed";
    ShipmentPaymentStatus["Paid"] = "paid";
    ShipmentPaymentStatus["Pending"] = "pending";
    ShipmentPaymentStatus["PendingSuccessfulCharge"] = "pendingSuccessfulCharge";
    ShipmentPaymentStatus["Voided"] = "voided";
})(ShipmentPaymentStatus = exports.ShipmentPaymentStatus || (exports.ShipmentPaymentStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ShipmentPayoutStatus;
(function (ShipmentPayoutStatus) {
    ShipmentPayoutStatus["Canceled"] = "canceled";
    ShipmentPayoutStatus["Failed"] = "failed";
    ShipmentPayoutStatus["Pending"] = "pending";
    ShipmentPayoutStatus["Succeeded"] = "succeeded";
    ShipmentPayoutStatus["Uninitiated"] = "uninitiated";
})(ShipmentPayoutStatus = exports.ShipmentPayoutStatus || (exports.ShipmentPayoutStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "asc";
    SortOrder["Desc"] = "desc";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SubsidiaryCountry;
(function (SubsidiaryCountry) {
    SubsidiaryCountry["UnitedStates"] = "United States";
})(SubsidiaryCountry = exports.SubsidiaryCountry || (exports.SubsidiaryCountry = {}));
/**
 *
 * @export
 * @enum {string}
 */
var VendorBillCreditType;
(function (VendorBillCreditType) {
    VendorBillCreditType["BaseShipment"] = "base_shipment";
    VendorBillCreditType["Other"] = "other";
})(VendorBillCreditType = exports.VendorBillCreditType || (exports.VendorBillCreditType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var VendorBillStatus;
(function (VendorBillStatus) {
    VendorBillStatus["Draft"] = "draft";
    VendorBillStatus["Open"] = "open";
    VendorBillStatus["PartialPayment"] = "partial-payment";
    VendorBillStatus["PaidInFull"] = "paid-in-full";
    VendorBillStatus["Voided"] = "voided";
})(VendorBillStatus = exports.VendorBillStatus || (exports.VendorBillStatus = {}));
/**
 * BillsLegacyApi - axios parameter creator
 * @export
 */
var BillsLegacyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create many legacy bills
         * @param {PostBillsBody} postBillsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postBillsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'postBillsBody' is not null or undefined
                    (0, common_1.assertParamExists)('createMany', 'postBillsBody', postBillsBody);
                    localVarPath = "/legacy/bills/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postBillsBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get legacy bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/legacy/bills/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many legacy bills
         * @param {number} [baseAmountCentsMin]
         * @param {Array<string>} [billIds]
         * @param {Array<string>} [netsuiteIds]
         * @param {Array<string>} [contactIds]
         * @param {number} [createdAfter]
         * @param {number} [createdBefore]
         * @param {string} [sortOrder]
         * @param {number} [limit]
         * @param {Array<string>} [ownerIds]
         * @param {BillOwnerType} [ownerTypes]
         * @param {PayoutSource} [payoutSources]
         * @param {Array<string>} [proNumbers]
         * @param {number} [skip]
         * @param {BillStatus} [statuses]
         * @param {BillType} [types]
         * @param {number} [updatedAtMax]
         * @param {number} [updatedAtMin]
         * @param {Array<string>} [userFirebaseKeys]
         * @param {Array<string>} [referenceNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (baseAmountCentsMin, billIds, netsuiteIds, contactIds, createdAfter, createdBefore, sortOrder, limit, ownerIds, ownerTypes, payoutSources, proNumbers, skip, statuses, types, updatedAtMax, updatedAtMin, userFirebaseKeys, referenceNumbers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/legacy/bills/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (baseAmountCentsMin !== undefined) {
                        localVarQueryParameter['baseAmountCentsMin'] = baseAmountCentsMin;
                    }
                    if (billIds) {
                        localVarQueryParameter['billIds'] = billIds;
                    }
                    if (netsuiteIds) {
                        localVarQueryParameter['netsuiteIds'] = netsuiteIds;
                    }
                    if (contactIds) {
                        localVarQueryParameter['contactIds'] = contactIds;
                    }
                    if (createdAfter !== undefined) {
                        localVarQueryParameter['createdAfter'] = createdAfter;
                    }
                    if (createdBefore !== undefined) {
                        localVarQueryParameter['createdBefore'] = createdBefore;
                    }
                    if (sortOrder !== undefined) {
                        localVarQueryParameter['sortOrder'] = sortOrder;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (ownerIds) {
                        localVarQueryParameter['ownerIds'] = ownerIds;
                    }
                    if (ownerTypes !== undefined) {
                        localVarQueryParameter['ownerTypes'] = ownerTypes;
                    }
                    if (payoutSources !== undefined) {
                        localVarQueryParameter['payoutSources'] = payoutSources;
                    }
                    if (proNumbers) {
                        localVarQueryParameter['proNumbers'] = proNumbers;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (statuses !== undefined) {
                        localVarQueryParameter['statuses'] = statuses;
                    }
                    if (types !== undefined) {
                        localVarQueryParameter['types'] = types;
                    }
                    if (updatedAtMax !== undefined) {
                        localVarQueryParameter['updatedAtMax'] = updatedAtMax;
                    }
                    if (updatedAtMin !== undefined) {
                        localVarQueryParameter['updatedAtMin'] = updatedAtMin;
                    }
                    if (userFirebaseKeys) {
                        localVarQueryParameter['userFirebaseKeys'] = userFirebaseKeys;
                    }
                    if (referenceNumbers) {
                        localVarQueryParameter['referenceNumbers'] = referenceNumbers;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update many legacy bills
         * @param {PatchBillsBody} patchBillsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchBillsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'patchBillsBody' is not null or undefined
                    (0, common_1.assertParamExists)('updateMany', 'patchBillsBody', patchBillsBody);
                    localVarPath = "/legacy/bills/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchBillsBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.BillsLegacyApiAxiosParamCreator = BillsLegacyApiAxiosParamCreator;
/**
 * BillsLegacyApi - functional programming interface
 * @export
 */
var BillsLegacyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BillsLegacyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create many legacy bills
         * @param {PostBillsBody} postBillsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postBillsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createMany(postBillsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get legacy bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many legacy bills
         * @param {number} [baseAmountCentsMin]
         * @param {Array<string>} [billIds]
         * @param {Array<string>} [netsuiteIds]
         * @param {Array<string>} [contactIds]
         * @param {number} [createdAfter]
         * @param {number} [createdBefore]
         * @param {string} [sortOrder]
         * @param {number} [limit]
         * @param {Array<string>} [ownerIds]
         * @param {BillOwnerType} [ownerTypes]
         * @param {PayoutSource} [payoutSources]
         * @param {Array<string>} [proNumbers]
         * @param {number} [skip]
         * @param {BillStatus} [statuses]
         * @param {BillType} [types]
         * @param {number} [updatedAtMax]
         * @param {number} [updatedAtMin]
         * @param {Array<string>} [userFirebaseKeys]
         * @param {Array<string>} [referenceNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (baseAmountCentsMin, billIds, netsuiteIds, contactIds, createdAfter, createdBefore, sortOrder, limit, ownerIds, ownerTypes, payoutSources, proNumbers, skip, statuses, types, updatedAtMax, updatedAtMin, userFirebaseKeys, referenceNumbers, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(baseAmountCentsMin, billIds, netsuiteIds, contactIds, createdAfter, createdBefore, sortOrder, limit, ownerIds, ownerTypes, payoutSources, proNumbers, skip, statuses, types, updatedAtMax, updatedAtMin, userFirebaseKeys, referenceNumbers, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update many legacy bills
         * @param {PatchBillsBody} patchBillsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchBillsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateMany(patchBillsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.BillsLegacyApiFp = BillsLegacyApiFp;
/**
 * BillsLegacyApi - factory interface
 * @export
 */
var BillsLegacyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BillsLegacyApiFp)(configuration);
    return {
        /**
         *
         * @summary Create many legacy bills
         * @param {PostBillsBody} postBillsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postBillsBody, options) {
            return localVarFp.createMany(postBillsBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get legacy bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many legacy bills
         * @param {number} [baseAmountCentsMin]
         * @param {Array<string>} [billIds]
         * @param {Array<string>} [netsuiteIds]
         * @param {Array<string>} [contactIds]
         * @param {number} [createdAfter]
         * @param {number} [createdBefore]
         * @param {string} [sortOrder]
         * @param {number} [limit]
         * @param {Array<string>} [ownerIds]
         * @param {BillOwnerType} [ownerTypes]
         * @param {PayoutSource} [payoutSources]
         * @param {Array<string>} [proNumbers]
         * @param {number} [skip]
         * @param {BillStatus} [statuses]
         * @param {BillType} [types]
         * @param {number} [updatedAtMax]
         * @param {number} [updatedAtMin]
         * @param {Array<string>} [userFirebaseKeys]
         * @param {Array<string>} [referenceNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (baseAmountCentsMin, billIds, netsuiteIds, contactIds, createdAfter, createdBefore, sortOrder, limit, ownerIds, ownerTypes, payoutSources, proNumbers, skip, statuses, types, updatedAtMax, updatedAtMin, userFirebaseKeys, referenceNumbers, options) {
            return localVarFp.getMany(baseAmountCentsMin, billIds, netsuiteIds, contactIds, createdAfter, createdBefore, sortOrder, limit, ownerIds, ownerTypes, payoutSources, proNumbers, skip, statuses, types, updatedAtMax, updatedAtMin, userFirebaseKeys, referenceNumbers, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update many legacy bills
         * @param {PatchBillsBody} patchBillsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchBillsBody, options) {
            return localVarFp.updateMany(patchBillsBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BillsLegacyApiFactory = BillsLegacyApiFactory;
/**
 * BillsLegacyApi - object-oriented interface
 * @export
 * @class BillsLegacyApi
 * @extends {BaseAPI}
 */
var BillsLegacyApi = /** @class */ (function (_super) {
    __extends(BillsLegacyApi, _super);
    function BillsLegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create many legacy bills
     * @param {BillsLegacyCreateManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillsLegacyApi
     */
    BillsLegacyApi.prototype.createMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.BillsLegacyApiFp)(this.configuration).createMany(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get legacy bill
     * @param {BillsLegacyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillsLegacyApi
     */
    BillsLegacyApi.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.BillsLegacyApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many legacy bills
     * @param {BillsLegacyGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillsLegacyApi
     */
    BillsLegacyApi.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.BillsLegacyApiFp)(this.configuration).getMany(requestParameters.baseAmountCentsMin, requestParameters.billIds, requestParameters.netsuiteIds, requestParameters.contactIds, requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.sortOrder, requestParameters.limit, requestParameters.ownerIds, requestParameters.ownerTypes, requestParameters.payoutSources, requestParameters.proNumbers, requestParameters.skip, requestParameters.statuses, requestParameters.types, requestParameters.updatedAtMax, requestParameters.updatedAtMin, requestParameters.userFirebaseKeys, requestParameters.referenceNumbers, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update many legacy bills
     * @param {BillsLegacyUpdateManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillsLegacyApi
     */
    BillsLegacyApi.prototype.updateMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.BillsLegacyApiFp)(this.configuration).updateMany(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return BillsLegacyApi;
}(base_1.BaseAPI));
exports.BillsLegacyApi = BillsLegacyApi;
/**
 * CompanyLegacyApi - axios parameter creator
 * @export
 */
var CompanyLegacyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get modified invoices
         * @param {string} id
         * @param {string} date
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiedInvoices: function (id, date, skip, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getModifiedInvoices', 'id', id);
                    // verify required parameter 'date' is not null or undefined
                    (0, common_1.assertParamExists)('getModifiedInvoices', 'date', date);
                    localVarPath = "/legacy/companies/v2/{id}/invoice-modified"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (date !== undefined) {
                        localVarQueryParameter['date'] = date;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CompanyLegacyApiAxiosParamCreator = CompanyLegacyApiAxiosParamCreator;
/**
 * CompanyLegacyApi - functional programming interface
 * @export
 */
var CompanyLegacyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CompanyLegacyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get modified invoices
         * @param {string} id
         * @param {string} date
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiedInvoices: function (id, date, skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getModifiedInvoices(id, date, skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CompanyLegacyApiFp = CompanyLegacyApiFp;
/**
 * CompanyLegacyApi - factory interface
 * @export
 */
var CompanyLegacyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CompanyLegacyApiFp)(configuration);
    return {
        /**
         *
         * @summary Get modified invoices
         * @param {string} id
         * @param {string} date
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModifiedInvoices: function (id, date, skip, limit, options) {
            return localVarFp.getModifiedInvoices(id, date, skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CompanyLegacyApiFactory = CompanyLegacyApiFactory;
/**
 * CompanyLegacyApi - object-oriented interface
 * @export
 * @class CompanyLegacyApi
 * @extends {BaseAPI}
 */
var CompanyLegacyApi = /** @class */ (function (_super) {
    __extends(CompanyLegacyApi, _super);
    function CompanyLegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get modified invoices
     * @param {CompanyLegacyGetModifiedInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyLegacyApi
     */
    CompanyLegacyApi.prototype.getModifiedInvoices = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CompanyLegacyApiFp)(this.configuration).getModifiedInvoices(requestParameters.id, requestParameters.date, requestParameters.skip, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return CompanyLegacyApi;
}(base_1.BaseAPI));
exports.CompanyLegacyApi = CompanyLegacyApi;
/**
 * ContactLegacyApi - axios parameter creator
 * @export
 */
var ContactLegacyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a Legacy contact
         * @param {PostContactsBody} postContactsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (postContactsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'postContactsBody' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'postContactsBody', postContactsBody);
                    localVarPath = "/legacy/contacts/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postContactsBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a Legacy contact
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/legacy/contacts/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many legacy contacts
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {Array<string>} [contactIds]
         * @param {Array<string>} [netsuiteIds]
         * @param {ContactType} [types]
         * @param {Array<string>} [organizationFirebaseKeys]
         * @param {Array<string>} [organizationNames]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, skip, contactIds, netsuiteIds, types, organizationFirebaseKeys, organizationNames, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/legacy/contacts/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (contactIds) {
                        localVarQueryParameter['contactIds'] = contactIds;
                    }
                    if (netsuiteIds) {
                        localVarQueryParameter['netsuiteIds'] = netsuiteIds;
                    }
                    if (types !== undefined) {
                        localVarQueryParameter['types'] = types;
                    }
                    if (organizationFirebaseKeys) {
                        localVarQueryParameter['organizationFirebaseKeys'] = organizationFirebaseKeys;
                    }
                    if (organizationNames) {
                        localVarQueryParameter['organizationNames'] = organizationNames;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a Legacy contact
         * @param {string} id
         * @param {PatchContactBody} patchContactBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, patchContactBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'patchContactBody' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'patchContactBody', patchContactBody);
                    localVarPath = "/legacy/contacts/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchContactBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ContactLegacyApiAxiosParamCreator = ContactLegacyApiAxiosParamCreator;
/**
 * ContactLegacyApi - functional programming interface
 * @export
 */
var ContactLegacyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ContactLegacyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create a Legacy contact
         * @param {PostContactsBody} postContactsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (postContactsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(postContactsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a Legacy contact
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many legacy contacts
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {Array<string>} [contactIds]
         * @param {Array<string>} [netsuiteIds]
         * @param {ContactType} [types]
         * @param {Array<string>} [organizationFirebaseKeys]
         * @param {Array<string>} [organizationNames]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, skip, contactIds, netsuiteIds, types, organizationFirebaseKeys, organizationNames, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, skip, contactIds, netsuiteIds, types, organizationFirebaseKeys, organizationNames, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Legacy contact
         * @param {string} id
         * @param {PatchContactBody} patchContactBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, patchContactBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, patchContactBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ContactLegacyApiFp = ContactLegacyApiFp;
/**
 * ContactLegacyApi - factory interface
 * @export
 */
var ContactLegacyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ContactLegacyApiFp)(configuration);
    return {
        /**
         *
         * @summary Create a Legacy contact
         * @param {PostContactsBody} postContactsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (postContactsBody, options) {
            return localVarFp.create(postContactsBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a Legacy contact
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many legacy contacts
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {Array<string>} [contactIds]
         * @param {Array<string>} [netsuiteIds]
         * @param {ContactType} [types]
         * @param {Array<string>} [organizationFirebaseKeys]
         * @param {Array<string>} [organizationNames]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, skip, contactIds, netsuiteIds, types, organizationFirebaseKeys, organizationNames, options) {
            return localVarFp.getMany(limit, skip, contactIds, netsuiteIds, types, organizationFirebaseKeys, organizationNames, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Legacy contact
         * @param {string} id
         * @param {PatchContactBody} patchContactBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, patchContactBody, options) {
            return localVarFp.update(id, patchContactBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ContactLegacyApiFactory = ContactLegacyApiFactory;
/**
 * ContactLegacyApi - object-oriented interface
 * @export
 * @class ContactLegacyApi
 * @extends {BaseAPI}
 */
var ContactLegacyApi = /** @class */ (function (_super) {
    __extends(ContactLegacyApi, _super);
    function ContactLegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a Legacy contact
     * @param {ContactLegacyCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactLegacyApi
     */
    ContactLegacyApi.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContactLegacyApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a Legacy contact
     * @param {ContactLegacyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactLegacyApi
     */
    ContactLegacyApi.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContactLegacyApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many legacy contacts
     * @param {ContactLegacyGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactLegacyApi
     */
    ContactLegacyApi.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ContactLegacyApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.skip, requestParameters.contactIds, requestParameters.netsuiteIds, requestParameters.types, requestParameters.organizationFirebaseKeys, requestParameters.organizationNames, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update a Legacy contact
     * @param {ContactLegacyUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactLegacyApi
     */
    ContactLegacyApi.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContactLegacyApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return ContactLegacyApi;
}(base_1.BaseAPI));
exports.ContactLegacyApi = ContactLegacyApi;
/**
 * CreditLegacyApi - axios parameter creator
 * @export
 */
var CreditLegacyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create many legacy credit
         * @param {PostCreditsBody} postCreditsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postCreditsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'postCreditsBody' is not null or undefined
                    (0, common_1.assertParamExists)('createMany', 'postCreditsBody', postCreditsBody);
                    localVarPath = "/legacy/credits/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postCreditsBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a legacy credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/legacy/credits/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many legacy credit
         * @param {string} [invoiceId]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {CreditType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (invoiceId, limit, skip, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/legacy/credits/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (invoiceId !== undefined) {
                        localVarQueryParameter['invoiceId'] = invoiceId;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (type !== undefined) {
                        localVarQueryParameter['type'] = type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update many legacy credit
         * @param {PatchCreditsBody} patchCreditsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchCreditsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'patchCreditsBody' is not null or undefined
                    (0, common_1.assertParamExists)('updateMany', 'patchCreditsBody', patchCreditsBody);
                    localVarPath = "/legacy/credits/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchCreditsBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CreditLegacyApiAxiosParamCreator = CreditLegacyApiAxiosParamCreator;
/**
 * CreditLegacyApi - functional programming interface
 * @export
 */
var CreditLegacyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CreditLegacyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create many legacy credit
         * @param {PostCreditsBody} postCreditsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postCreditsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createMany(postCreditsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a legacy credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many legacy credit
         * @param {string} [invoiceId]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {CreditType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (invoiceId, limit, skip, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(invoiceId, limit, skip, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update many legacy credit
         * @param {PatchCreditsBody} patchCreditsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchCreditsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateMany(patchCreditsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CreditLegacyApiFp = CreditLegacyApiFp;
/**
 * CreditLegacyApi - factory interface
 * @export
 */
var CreditLegacyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CreditLegacyApiFp)(configuration);
    return {
        /**
         *
         * @summary Create many legacy credit
         * @param {PostCreditsBody} postCreditsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postCreditsBody, options) {
            return localVarFp.createMany(postCreditsBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a legacy credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many legacy credit
         * @param {string} [invoiceId]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {CreditType} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (invoiceId, limit, skip, type, options) {
            return localVarFp.getMany(invoiceId, limit, skip, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update many legacy credit
         * @param {PatchCreditsBody} patchCreditsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchCreditsBody, options) {
            return localVarFp.updateMany(patchCreditsBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CreditLegacyApiFactory = CreditLegacyApiFactory;
/**
 * CreditLegacyApi - object-oriented interface
 * @export
 * @class CreditLegacyApi
 * @extends {BaseAPI}
 */
var CreditLegacyApi = /** @class */ (function (_super) {
    __extends(CreditLegacyApi, _super);
    function CreditLegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create many legacy credit
     * @param {CreditLegacyCreateManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditLegacyApi
     */
    CreditLegacyApi.prototype.createMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CreditLegacyApiFp)(this.configuration).createMany(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a legacy credit
     * @param {CreditLegacyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditLegacyApi
     */
    CreditLegacyApi.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CreditLegacyApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many legacy credit
     * @param {CreditLegacyGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditLegacyApi
     */
    CreditLegacyApi.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.CreditLegacyApiFp)(this.configuration).getMany(requestParameters.invoiceId, requestParameters.limit, requestParameters.skip, requestParameters.type, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update many legacy credit
     * @param {CreditLegacyUpdateManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditLegacyApi
     */
    CreditLegacyApi.prototype.updateMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CreditLegacyApiFp)(this.configuration).updateMany(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return CreditLegacyApi;
}(base_1.BaseAPI));
exports.CreditLegacyApi = CreditLegacyApi;
/**
 * CreditV2LegacyApi - axios parameter creator
 * @export
 */
var CreditV2LegacyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get a legacy company credit v2
         * @param {string} id
         * @param {Array<string>} [type]
         * @param {Array<string>} [types]
         * @param {boolean} [includeExpired]
         * @param {boolean} [excludeDepleted]
         * @param {boolean} [includeApplications]
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesV2get: function (id, type, types, includeExpired, excludeDepleted, includeApplications, skip, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('companiesV2get', 'id', id);
                    localVarPath = "/legacy/companies/v2/{id}/credits"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (type) {
                        localVarQueryParameter['type'] = type;
                    }
                    if (types) {
                        localVarQueryParameter['types'] = types;
                    }
                    if (includeExpired !== undefined) {
                        localVarQueryParameter['includeExpired'] = includeExpired;
                    }
                    if (excludeDepleted !== undefined) {
                        localVarQueryParameter['excludeDepleted'] = excludeDepleted;
                    }
                    if (includeApplications !== undefined) {
                        localVarQueryParameter['includeApplications'] = includeApplications;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a legacy company credit analytics
         * @param {string} id
         * @param {CreditType} [types]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesV2getCreditsAnalytics: function (id, types, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('companiesV2getCreditsAnalytics', 'id', id);
                    localVarPath = "/legacy/companies/v2/{id}/credits-analytics"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (types !== undefined) {
                        localVarQueryParameter['types'] = types;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create legacy creditV2s
         * @param {ICreateCreditRequestDto} iCreateCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditV2createMany: function (iCreateCreditRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iCreateCreditRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('creditV2createMany', 'iCreateCreditRequestDto', iCreateCreditRequestDto);
                    localVarPath = "/legacy/credits/v2";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateCreditRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a legacy credit v2
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditV2get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('creditV2get', 'id', id);
                    localVarPath = "/legacy/credits/v2/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many legacy credit v2
         * @param {Array<string>} [ids]
         * @param {boolean} [includeApplications]
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditV2getMany: function (ids, includeApplications, skip, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/legacy/credits/v2";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ids) {
                        localVarQueryParameter['ids'] = ids;
                    }
                    if (includeApplications !== undefined) {
                        localVarQueryParameter['includeApplications'] = includeApplications;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Apply credits to an invoice
         * @param {string} id
         * @param {IApplyCreditOnInvoiceRequestDto} iApplyCreditOnInvoiceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesV2applyCreditsToInvoice: function (id, iApplyCreditOnInvoiceRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('invoicesV2applyCreditsToInvoice', 'id', id);
                    // verify required parameter 'iApplyCreditOnInvoiceRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('invoicesV2applyCreditsToInvoice', 'iApplyCreditOnInvoiceRequestDto', iApplyCreditOnInvoiceRequestDto);
                    localVarPath = "/legacy/invoices/v2/{id}/apply-credit"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iApplyCreditOnInvoiceRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a legacy invoice credit v2
         * @param {string} id
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesV2get: function (id, skip, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('invoicesV2get', 'id', id);
                    localVarPath = "/legacy/invoices/v2/{id}/credits"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Unapply a credit from an invoice
         * @param {string} id
         * @param {IUnapplyCreditsFromInvoiceRequest} iUnapplyCreditsFromInvoiceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesV2unapplyCreditsToInvoice: function (id, iUnapplyCreditsFromInvoiceRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('invoicesV2unapplyCreditsToInvoice', 'id', id);
                    // verify required parameter 'iUnapplyCreditsFromInvoiceRequest' is not null or undefined
                    (0, common_1.assertParamExists)('invoicesV2unapplyCreditsToInvoice', 'iUnapplyCreditsFromInvoiceRequest', iUnapplyCreditsFromInvoiceRequest);
                    localVarPath = "/legacy/invoices/v2/{id}/unapply-credits"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUnapplyCreditsFromInvoiceRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CreditV2LegacyApiAxiosParamCreator = CreditV2LegacyApiAxiosParamCreator;
/**
 * CreditV2LegacyApi - functional programming interface
 * @export
 */
var CreditV2LegacyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CreditV2LegacyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get a legacy company credit v2
         * @param {string} id
         * @param {Array<string>} [type]
         * @param {Array<string>} [types]
         * @param {boolean} [includeExpired]
         * @param {boolean} [excludeDepleted]
         * @param {boolean} [includeApplications]
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesV2get: function (id, type, types, includeExpired, excludeDepleted, includeApplications, skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesV2get(id, type, types, includeExpired, excludeDepleted, includeApplications, skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a legacy company credit analytics
         * @param {string} id
         * @param {CreditType} [types]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesV2getCreditsAnalytics: function (id, types, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesV2getCreditsAnalytics(id, types, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create legacy creditV2s
         * @param {ICreateCreditRequestDto} iCreateCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditV2createMany: function (iCreateCreditRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.creditV2createMany(iCreateCreditRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a legacy credit v2
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditV2get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.creditV2get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many legacy credit v2
         * @param {Array<string>} [ids]
         * @param {boolean} [includeApplications]
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditV2getMany: function (ids, includeApplications, skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.creditV2getMany(ids, includeApplications, skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Apply credits to an invoice
         * @param {string} id
         * @param {IApplyCreditOnInvoiceRequestDto} iApplyCreditOnInvoiceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesV2applyCreditsToInvoice: function (id, iApplyCreditOnInvoiceRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicesV2applyCreditsToInvoice(id, iApplyCreditOnInvoiceRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a legacy invoice credit v2
         * @param {string} id
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesV2get: function (id, skip, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicesV2get(id, skip, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Unapply a credit from an invoice
         * @param {string} id
         * @param {IUnapplyCreditsFromInvoiceRequest} iUnapplyCreditsFromInvoiceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesV2unapplyCreditsToInvoice: function (id, iUnapplyCreditsFromInvoiceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicesV2unapplyCreditsToInvoice(id, iUnapplyCreditsFromInvoiceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CreditV2LegacyApiFp = CreditV2LegacyApiFp;
/**
 * CreditV2LegacyApi - factory interface
 * @export
 */
var CreditV2LegacyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CreditV2LegacyApiFp)(configuration);
    return {
        /**
         *
         * @summary Get a legacy company credit v2
         * @param {string} id
         * @param {Array<string>} [type]
         * @param {Array<string>} [types]
         * @param {boolean} [includeExpired]
         * @param {boolean} [excludeDepleted]
         * @param {boolean} [includeApplications]
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesV2get: function (id, type, types, includeExpired, excludeDepleted, includeApplications, skip, limit, options) {
            return localVarFp.companiesV2get(id, type, types, includeExpired, excludeDepleted, includeApplications, skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a legacy company credit analytics
         * @param {string} id
         * @param {CreditType} [types]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesV2getCreditsAnalytics: function (id, types, options) {
            return localVarFp.companiesV2getCreditsAnalytics(id, types, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create legacy creditV2s
         * @param {ICreateCreditRequestDto} iCreateCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditV2createMany: function (iCreateCreditRequestDto, options) {
            return localVarFp.creditV2createMany(iCreateCreditRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a legacy credit v2
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditV2get: function (id, options) {
            return localVarFp.creditV2get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many legacy credit v2
         * @param {Array<string>} [ids]
         * @param {boolean} [includeApplications]
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditV2getMany: function (ids, includeApplications, skip, limit, options) {
            return localVarFp.creditV2getMany(ids, includeApplications, skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Apply credits to an invoice
         * @param {string} id
         * @param {IApplyCreditOnInvoiceRequestDto} iApplyCreditOnInvoiceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesV2applyCreditsToInvoice: function (id, iApplyCreditOnInvoiceRequestDto, options) {
            return localVarFp.invoicesV2applyCreditsToInvoice(id, iApplyCreditOnInvoiceRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a legacy invoice credit v2
         * @param {string} id
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesV2get: function (id, skip, limit, options) {
            return localVarFp.invoicesV2get(id, skip, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Unapply a credit from an invoice
         * @param {string} id
         * @param {IUnapplyCreditsFromInvoiceRequest} iUnapplyCreditsFromInvoiceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesV2unapplyCreditsToInvoice: function (id, iUnapplyCreditsFromInvoiceRequest, options) {
            return localVarFp.invoicesV2unapplyCreditsToInvoice(id, iUnapplyCreditsFromInvoiceRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CreditV2LegacyApiFactory = CreditV2LegacyApiFactory;
/**
 * CreditV2LegacyApi - object-oriented interface
 * @export
 * @class CreditV2LegacyApi
 * @extends {BaseAPI}
 */
var CreditV2LegacyApi = /** @class */ (function (_super) {
    __extends(CreditV2LegacyApi, _super);
    function CreditV2LegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get a legacy company credit v2
     * @param {CreditV2LegacyApiCompaniesV2getRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditV2LegacyApi
     */
    CreditV2LegacyApi.prototype.companiesV2get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CreditV2LegacyApiFp)(this.configuration).companiesV2get(requestParameters.id, requestParameters.type, requestParameters.types, requestParameters.includeExpired, requestParameters.excludeDepleted, requestParameters.includeApplications, requestParameters.skip, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a legacy company credit analytics
     * @param {CreditV2LegacyApiCompaniesV2getCreditsAnalyticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditV2LegacyApi
     */
    CreditV2LegacyApi.prototype.companiesV2getCreditsAnalytics = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CreditV2LegacyApiFp)(this.configuration).companiesV2getCreditsAnalytics(requestParameters.id, requestParameters.types, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Create legacy creditV2s
     * @param {CreditV2LegacyApiCreditV2createManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditV2LegacyApi
     */
    CreditV2LegacyApi.prototype.creditV2createMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CreditV2LegacyApiFp)(this.configuration).creditV2createMany(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a legacy credit v2
     * @param {CreditV2LegacyApiCreditV2getRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditV2LegacyApi
     */
    CreditV2LegacyApi.prototype.creditV2get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CreditV2LegacyApiFp)(this.configuration).creditV2get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many legacy credit v2
     * @param {CreditV2LegacyApiCreditV2getManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditV2LegacyApi
     */
    CreditV2LegacyApi.prototype.creditV2getMany = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.CreditV2LegacyApiFp)(this.configuration).creditV2getMany(requestParameters.ids, requestParameters.includeApplications, requestParameters.skip, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Apply credits to an invoice
     * @param {CreditV2LegacyApiInvoicesV2applyCreditsToInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditV2LegacyApi
     */
    CreditV2LegacyApi.prototype.invoicesV2applyCreditsToInvoice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CreditV2LegacyApiFp)(this.configuration).invoicesV2applyCreditsToInvoice(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a legacy invoice credit v2
     * @param {CreditV2LegacyApiInvoicesV2getRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditV2LegacyApi
     */
    CreditV2LegacyApi.prototype.invoicesV2get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CreditV2LegacyApiFp)(this.configuration).invoicesV2get(requestParameters.id, requestParameters.skip, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Unapply a credit from an invoice
     * @param {CreditV2LegacyApiInvoicesV2unapplyCreditsToInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditV2LegacyApi
     */
    CreditV2LegacyApi.prototype.invoicesV2unapplyCreditsToInvoice = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CreditV2LegacyApiFp)(this.configuration).invoicesV2unapplyCreditsToInvoice(requestParameters.id, requestParameters.iUnapplyCreditsFromInvoiceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return CreditV2LegacyApi;
}(base_1.BaseAPI));
exports.CreditV2LegacyApi = CreditV2LegacyApi;
/**
 * CustomerCreditMemoV1Api - axios parameter creator
 * @export
 */
var CustomerCreditMemoV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Apply a credit memo
         * @param {string} id
         * @param {ApplyCustomerCreditMemoRequestDto} applyCustomerCreditMemoRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyCustomerCreditMemoRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('apply', 'id', id);
                    // verify required parameter 'applyCustomerCreditMemoRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('apply', 'applyCustomerCreditMemoRequestDto', applyCustomerCreditMemoRequestDto);
                    localVarPath = "/customer-credit-memo/v1/{id}/apply"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(applyCustomerCreditMemoRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create a credit memo
         * @param {CreateCustomerCreditMemoRequestDto} createCustomerCreditMemoRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerCreditMemoRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createCustomerCreditMemoRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createCustomerCreditMemoRequestDto', createCustomerCreditMemoRequestDto);
                    localVarPath = "/customer-credit-memo/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCustomerCreditMemoRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a customer credit memo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delete', 'id', id);
                    localVarPath = "/customer-credit-memo/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a credit memo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/customer-credit-memo/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a credit memo aggregation
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerCreditMemoFiltersRequestDto} [filters] Query filters for the customer credit memos
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the credit memos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregation: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getAggregation', 'limit', limit);
                    localVarPath = "/customer-credit-memo/v1/aggregation";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a credit memo by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'referenceNumber' is not null or undefined
                    (0, common_1.assertParamExists)('getByReferenceNumber', 'referenceNumber', referenceNumber);
                    localVarPath = "/customer-credit-memo/v1/reference-number/{referenceNumber}"
                        .replace("{".concat("referenceNumber", "}"), encodeURIComponent(String(referenceNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many customer credit memos
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerCreditMemoFiltersRequestDto} [filters] Query filters for the customer credit memos
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the credit memos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/customer-credit-memo/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary List applications for a customer credit memo
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {SortOrder} [id2] Order filter for the id
         * @param {SortOrder} [createdAt] Order filter for the createdAt
         * @param {SortOrder} [updated] Order filter for the updatedAt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplications: function (id, limit, offset, id2, createdAt, updated, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('listApplications', 'id', id);
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('listApplications', 'limit', limit);
                    localVarPath = "/customer-credit-memo/v1/{id}/applications"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (id2 !== undefined) {
                        localVarQueryParameter['id'] = id2;
                    }
                    if (createdAt !== undefined) {
                        localVarQueryParameter['createdAt'] = createdAt;
                    }
                    if (updated !== undefined) {
                        localVarQueryParameter['updated'] = updated;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Refresh a credit memo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('refresh', 'id', id);
                    localVarPath = "/customer-credit-memo/v1/{id}/refresh"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Unapply a credit memo application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('unapplyApplication', 'id', id);
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('unapplyApplication', 'applicationId', applicationId);
                    localVarPath = "/customer-credit-memo/v1/{id}/applications/{applicationId}/unapply"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a credit memo
         * @param {string} id
         * @param {UpdateCustomerCreditMemoRequestDto} updateCustomerCreditMemoRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerCreditMemoRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'updateCustomerCreditMemoRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'updateCustomerCreditMemoRequestDto', updateCustomerCreditMemoRequestDto);
                    localVarPath = "/customer-credit-memo/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCustomerCreditMemoRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CustomerCreditMemoV1ApiAxiosParamCreator = CustomerCreditMemoV1ApiAxiosParamCreator;
/**
 * CustomerCreditMemoV1Api - functional programming interface
 * @export
 */
var CustomerCreditMemoV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomerCreditMemoV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Apply a credit memo
         * @param {string} id
         * @param {ApplyCustomerCreditMemoRequestDto} applyCustomerCreditMemoRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyCustomerCreditMemoRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apply(id, applyCustomerCreditMemoRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a credit memo
         * @param {CreateCustomerCreditMemoRequestDto} createCustomerCreditMemoRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerCreditMemoRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createCustomerCreditMemoRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a customer credit memo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a credit memo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a credit memo aggregation
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerCreditMemoFiltersRequestDto} [filters] Query filters for the customer credit memos
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the credit memos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregation: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAggregation(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a credit memo by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getByReferenceNumber(referenceNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many customer credit memos
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerCreditMemoFiltersRequestDto} [filters] Query filters for the customer credit memos
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the credit memos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List applications for a customer credit memo
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {SortOrder} [id2] Order filter for the id
         * @param {SortOrder} [createdAt] Order filter for the createdAt
         * @param {SortOrder} [updated] Order filter for the updatedAt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplications: function (id, limit, offset, id2, createdAt, updated, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listApplications(id, limit, offset, id2, createdAt, updated, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Refresh a credit memo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refresh(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Unapply a credit memo application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.unapplyApplication(id, applicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a credit memo
         * @param {string} id
         * @param {UpdateCustomerCreditMemoRequestDto} updateCustomerCreditMemoRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerCreditMemoRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, updateCustomerCreditMemoRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CustomerCreditMemoV1ApiFp = CustomerCreditMemoV1ApiFp;
/**
 * CustomerCreditMemoV1Api - factory interface
 * @export
 */
var CustomerCreditMemoV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomerCreditMemoV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Apply a credit memo
         * @param {string} id
         * @param {ApplyCustomerCreditMemoRequestDto} applyCustomerCreditMemoRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyCustomerCreditMemoRequestDto, options) {
            return localVarFp.apply(id, applyCustomerCreditMemoRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a credit memo
         * @param {CreateCustomerCreditMemoRequestDto} createCustomerCreditMemoRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerCreditMemoRequestDto, options) {
            return localVarFp.create(createCustomerCreditMemoRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a customer credit memo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return localVarFp.delete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a credit memo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a credit memo aggregation
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerCreditMemoFiltersRequestDto} [filters] Query filters for the customer credit memos
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the credit memos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregation: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getAggregation(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a credit memo by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return localVarFp.getByReferenceNumber(referenceNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many customer credit memos
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerCreditMemoFiltersRequestDto} [filters] Query filters for the customer credit memos
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the credit memos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List applications for a customer credit memo
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {SortOrder} [id2] Order filter for the id
         * @param {SortOrder} [createdAt] Order filter for the createdAt
         * @param {SortOrder} [updated] Order filter for the updatedAt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApplications: function (id, limit, offset, id2, createdAt, updated, options) {
            return localVarFp.listApplications(id, limit, offset, id2, createdAt, updated, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Refresh a credit memo
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return localVarFp.refresh(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Unapply a credit memo application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            return localVarFp.unapplyApplication(id, applicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a credit memo
         * @param {string} id
         * @param {UpdateCustomerCreditMemoRequestDto} updateCustomerCreditMemoRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerCreditMemoRequestDto, options) {
            return localVarFp.update(id, updateCustomerCreditMemoRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomerCreditMemoV1ApiFactory = CustomerCreditMemoV1ApiFactory;
/**
 * CustomerCreditMemoV1Api - object-oriented interface
 * @export
 * @class CustomerCreditMemoV1Api
 * @extends {BaseAPI}
 */
var CustomerCreditMemoV1Api = /** @class */ (function (_super) {
    __extends(CustomerCreditMemoV1Api, _super);
    function CustomerCreditMemoV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Apply a credit memo
     * @param {CustomerCreditMemoV1ApplyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCreditMemoV1Api
     */
    CustomerCreditMemoV1Api.prototype.apply = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerCreditMemoV1ApiFp)(this.configuration).apply(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Create a credit memo
     * @param {CustomerCreditMemoV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCreditMemoV1Api
     */
    CustomerCreditMemoV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerCreditMemoV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Delete a customer credit memo
     * @param {CustomerCreditMemoV1DeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCreditMemoV1Api
     */
    CustomerCreditMemoV1Api.prototype.delete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerCreditMemoV1ApiFp)(this.configuration).delete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a credit memo
     * @param {CustomerCreditMemoV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCreditMemoV1Api
     */
    CustomerCreditMemoV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerCreditMemoV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a credit memo aggregation
     * @param {CustomerCreditMemoV1GetAggregationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCreditMemoV1Api
     */
    CustomerCreditMemoV1Api.prototype.getAggregation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerCreditMemoV1ApiFp)(this.configuration).getAggregation(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a credit memo by reference number
     * @param {CustomerCreditMemoV1GetByReferenceNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCreditMemoV1Api
     */
    CustomerCreditMemoV1Api.prototype.getByReferenceNumber = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerCreditMemoV1ApiFp)(this.configuration).getByReferenceNumber(requestParameters.referenceNumber, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many customer credit memos
     * @param {CustomerCreditMemoV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCreditMemoV1Api
     */
    CustomerCreditMemoV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerCreditMemoV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary List applications for a customer credit memo
     * @param {CustomerCreditMemoV1ListApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCreditMemoV1Api
     */
    CustomerCreditMemoV1Api.prototype.listApplications = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerCreditMemoV1ApiFp)(this.configuration).listApplications(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.id2, requestParameters.createdAt, requestParameters.updated, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Refresh a credit memo
     * @param {CustomerCreditMemoV1RefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCreditMemoV1Api
     */
    CustomerCreditMemoV1Api.prototype.refresh = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerCreditMemoV1ApiFp)(this.configuration).refresh(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Unapply a credit memo application
     * @param {CustomerCreditMemoV1UnapplyApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCreditMemoV1Api
     */
    CustomerCreditMemoV1Api.prototype.unapplyApplication = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerCreditMemoV1ApiFp)(this.configuration).unapplyApplication(requestParameters.id, requestParameters.applicationId, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update a credit memo
     * @param {CustomerCreditMemoV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerCreditMemoV1Api
     */
    CustomerCreditMemoV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerCreditMemoV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return CustomerCreditMemoV1Api;
}(base_1.BaseAPI));
exports.CustomerCreditMemoV1Api = CustomerCreditMemoV1Api;
/**
 * CustomerInvoiceApplicationV1Api - axios parameter creator
 * @export
 */
var CustomerInvoiceApplicationV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete a customer invoice application
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delete', 'id', id);
                    localVarPath = "/customer-invoice-application/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many customer invoice applications
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {boolean} [includeUnapplied] Should unapplied applications be included in the response
         * @param {GetManyCustomerInvoiceApplicationFiltersRequestDto} [filters] Query filters for the customer invoice applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer invoice applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, includeUnapplied, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/customer-invoice-application/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (includeUnapplied !== undefined) {
                        localVarQueryParameter['includeUnapplied'] = includeUnapplied;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CustomerInvoiceApplicationV1ApiAxiosParamCreator = CustomerInvoiceApplicationV1ApiAxiosParamCreator;
/**
 * CustomerInvoiceApplicationV1Api - functional programming interface
 * @export
 */
var CustomerInvoiceApplicationV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomerInvoiceApplicationV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete a customer invoice application
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many customer invoice applications
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {boolean} [includeUnapplied] Should unapplied applications be included in the response
         * @param {GetManyCustomerInvoiceApplicationFiltersRequestDto} [filters] Query filters for the customer invoice applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer invoice applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, includeUnapplied, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, includeUnapplied, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CustomerInvoiceApplicationV1ApiFp = CustomerInvoiceApplicationV1ApiFp;
/**
 * CustomerInvoiceApplicationV1Api - factory interface
 * @export
 */
var CustomerInvoiceApplicationV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomerInvoiceApplicationV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete a customer invoice application
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return localVarFp.delete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many customer invoice applications
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {boolean} [includeUnapplied] Should unapplied applications be included in the response
         * @param {GetManyCustomerInvoiceApplicationFiltersRequestDto} [filters] Query filters for the customer invoice applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer invoice applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, includeUnapplied, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, includeUnapplied, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomerInvoiceApplicationV1ApiFactory = CustomerInvoiceApplicationV1ApiFactory;
/**
 * CustomerInvoiceApplicationV1Api - object-oriented interface
 * @export
 * @class CustomerInvoiceApplicationV1Api
 * @extends {BaseAPI}
 */
var CustomerInvoiceApplicationV1Api = /** @class */ (function (_super) {
    __extends(CustomerInvoiceApplicationV1Api, _super);
    function CustomerInvoiceApplicationV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete a customer invoice application
     * @param {CustomerInvoiceApplicationV1DeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceApplicationV1Api
     */
    CustomerInvoiceApplicationV1Api.prototype.delete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceApplicationV1ApiFp)(this.configuration).delete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many customer invoice applications
     * @param {CustomerInvoiceApplicationV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceApplicationV1Api
     */
    CustomerInvoiceApplicationV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceApplicationV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.includeUnapplied, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return CustomerInvoiceApplicationV1Api;
}(base_1.BaseAPI));
exports.CustomerInvoiceApplicationV1Api = CustomerInvoiceApplicationV1Api;
/**
 * CustomerInvoiceV1Api - axios parameter creator
 * @export
 */
var CustomerInvoiceV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get a customer invoices applications
         * @summary Get a customer invoices applications
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {boolean} [includeUnapplied] Should unapplied applications be included in the response
         * @param {GetManyCustomerInvoiceApplicationFiltersRequestDto} [filters] Query filters for the customer invoice applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer invoice applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applications: function (id, limit, offset, includeUnapplied, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('applications', 'id', id);
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('applications', 'limit', limit);
                    localVarPath = "/customer-invoice/v1/{id}/applications"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (includeUnapplied !== undefined) {
                        localVarQueryParameter['includeUnapplied'] = includeUnapplied;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create an invoice
         * @summary Create an invoice
         * @param {CreateCustomerInvoiceRequestDto} createCustomerInvoiceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerInvoiceRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createCustomerInvoiceRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createCustomerInvoiceRequestDto', createCustomerInvoiceRequestDto);
                    localVarPath = "/customer-invoice/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCustomerInvoiceRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete an invoice
         * @summary Delete an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delete', 'id', id);
                    localVarPath = "/customer-invoice/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get an invoice
         * @summary Get an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/customer-invoice/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a customer invoice by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'referenceNumber' is not null or undefined
                    (0, common_1.assertParamExists)('getByReferenceNumber', 'referenceNumber', referenceNumber);
                    localVarPath = "/customer-invoice/v1/reference-number/{referenceNumber}"
                        .replace("{".concat("referenceNumber", "}"), encodeURIComponent(String(referenceNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get an invoice line items
         * @summary Get an invoices line items
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineItems: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getLineItems', 'id', id);
                    localVarPath = "/customer-invoice/v1/{id}/line-items"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many customer invoices
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerInvoiceFiltersRequestDto} [filters] Query filters for the customer invoices
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/customer-invoice/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Refresh an invoice
         * @summary Refresh an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('refresh', 'id', id);
                    localVarPath = "/customer-invoice/v1/{id}/refresh"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Replace an invoices line items
         * @summary Replace an invoice\'s line items
         * @param {string} id
         * @param {ReplaceCustomerInvoiceLineItemsRequestDto} replaceCustomerInvoiceLineItemsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceLineItems: function (id, replaceCustomerInvoiceLineItemsRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('replaceLineItems', 'id', id);
                    // verify required parameter 'replaceCustomerInvoiceLineItemsRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('replaceLineItems', 'replaceCustomerInvoiceLineItemsRequestDto', replaceCustomerInvoiceLineItemsRequestDto);
                    localVarPath = "/customer-invoice/v1/{id}/line-items"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(replaceCustomerInvoiceLineItemsRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update an invoice
         * @summary Update an invoice
         * @param {string} id
         * @param {UpdateCustomerInvoiceRequestDto} updateCustomerInvoiceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerInvoiceRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'updateCustomerInvoiceRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'updateCustomerInvoiceRequestDto', updateCustomerInvoiceRequestDto);
                    localVarPath = "/customer-invoice/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCustomerInvoiceRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Void an invoice
         * @summary Void an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        void: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('void', 'id', id);
                    localVarPath = "/customer-invoice/v1/{id}/void"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CustomerInvoiceV1ApiAxiosParamCreator = CustomerInvoiceV1ApiAxiosParamCreator;
/**
 * CustomerInvoiceV1Api - functional programming interface
 * @export
 */
var CustomerInvoiceV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomerInvoiceV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get a customer invoices applications
         * @summary Get a customer invoices applications
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {boolean} [includeUnapplied] Should unapplied applications be included in the response
         * @param {GetManyCustomerInvoiceApplicationFiltersRequestDto} [filters] Query filters for the customer invoice applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer invoice applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applications: function (id, limit, offset, includeUnapplied, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.applications(id, limit, offset, includeUnapplied, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create an invoice
         * @summary Create an invoice
         * @param {CreateCustomerInvoiceRequestDto} createCustomerInvoiceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerInvoiceRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createCustomerInvoiceRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete an invoice
         * @summary Delete an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get an invoice
         * @summary Get an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a customer invoice by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getByReferenceNumber(referenceNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get an invoice line items
         * @summary Get an invoices line items
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineItems: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLineItems(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many customer invoices
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerInvoiceFiltersRequestDto} [filters] Query filters for the customer invoices
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Refresh an invoice
         * @summary Refresh an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refresh(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Replace an invoices line items
         * @summary Replace an invoice\'s line items
         * @param {string} id
         * @param {ReplaceCustomerInvoiceLineItemsRequestDto} replaceCustomerInvoiceLineItemsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceLineItems: function (id, replaceCustomerInvoiceLineItemsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.replaceLineItems(id, replaceCustomerInvoiceLineItemsRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update an invoice
         * @summary Update an invoice
         * @param {string} id
         * @param {UpdateCustomerInvoiceRequestDto} updateCustomerInvoiceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerInvoiceRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, updateCustomerInvoiceRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Void an invoice
         * @summary Void an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        void: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.void(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CustomerInvoiceV1ApiFp = CustomerInvoiceV1ApiFp;
/**
 * CustomerInvoiceV1Api - factory interface
 * @export
 */
var CustomerInvoiceV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomerInvoiceV1ApiFp)(configuration);
    return {
        /**
         * Get a customer invoices applications
         * @summary Get a customer invoices applications
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {boolean} [includeUnapplied] Should unapplied applications be included in the response
         * @param {GetManyCustomerInvoiceApplicationFiltersRequestDto} [filters] Query filters for the customer invoice applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer invoice applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applications: function (id, limit, offset, includeUnapplied, filters, orderBy, options) {
            return localVarFp.applications(id, limit, offset, includeUnapplied, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create an invoice
         * @summary Create an invoice
         * @param {CreateCustomerInvoiceRequestDto} createCustomerInvoiceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerInvoiceRequestDto, options) {
            return localVarFp.create(createCustomerInvoiceRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an invoice
         * @summary Delete an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return localVarFp.delete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get an invoice
         * @summary Get an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a customer invoice by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return localVarFp.getByReferenceNumber(referenceNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get an invoice line items
         * @summary Get an invoices line items
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineItems: function (id, options) {
            return localVarFp.getLineItems(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many customer invoices
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerInvoiceFiltersRequestDto} [filters] Query filters for the customer invoices
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Refresh an invoice
         * @summary Refresh an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return localVarFp.refresh(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Replace an invoices line items
         * @summary Replace an invoice\'s line items
         * @param {string} id
         * @param {ReplaceCustomerInvoiceLineItemsRequestDto} replaceCustomerInvoiceLineItemsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceLineItems: function (id, replaceCustomerInvoiceLineItemsRequestDto, options) {
            return localVarFp.replaceLineItems(id, replaceCustomerInvoiceLineItemsRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update an invoice
         * @summary Update an invoice
         * @param {string} id
         * @param {UpdateCustomerInvoiceRequestDto} updateCustomerInvoiceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerInvoiceRequestDto, options) {
            return localVarFp.update(id, updateCustomerInvoiceRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Void an invoice
         * @summary Void an invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        void: function (id, options) {
            return localVarFp.void(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomerInvoiceV1ApiFactory = CustomerInvoiceV1ApiFactory;
/**
 * CustomerInvoiceV1Api - object-oriented interface
 * @export
 * @class CustomerInvoiceV1Api
 * @extends {BaseAPI}
 */
var CustomerInvoiceV1Api = /** @class */ (function (_super) {
    __extends(CustomerInvoiceV1Api, _super);
    function CustomerInvoiceV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get a customer invoices applications
     * @summary Get a customer invoices applications
     * @param {CustomerInvoiceV1ApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceV1Api
     */
    CustomerInvoiceV1Api.prototype.applications = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceV1ApiFp)(this.configuration).applications(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.includeUnapplied, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Create an invoice
     * @summary Create an invoice
     * @param {CustomerInvoiceV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceV1Api
     */
    CustomerInvoiceV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Delete an invoice
     * @summary Delete an invoice
     * @param {CustomerInvoiceV1DeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceV1Api
     */
    CustomerInvoiceV1Api.prototype.delete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceV1ApiFp)(this.configuration).delete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Get an invoice
     * @summary Get an invoice
     * @param {CustomerInvoiceV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceV1Api
     */
    CustomerInvoiceV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a customer invoice by reference number
     * @param {CustomerInvoiceV1GetByReferenceNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceV1Api
     */
    CustomerInvoiceV1Api.prototype.getByReferenceNumber = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceV1ApiFp)(this.configuration).getByReferenceNumber(requestParameters.referenceNumber, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Get an invoice line items
     * @summary Get an invoices line items
     * @param {CustomerInvoiceV1GetLineItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceV1Api
     */
    CustomerInvoiceV1Api.prototype.getLineItems = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceV1ApiFp)(this.configuration).getLineItems(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many customer invoices
     * @param {CustomerInvoiceV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceV1Api
     */
    CustomerInvoiceV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Refresh an invoice
     * @summary Refresh an invoice
     * @param {CustomerInvoiceV1RefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceV1Api
     */
    CustomerInvoiceV1Api.prototype.refresh = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceV1ApiFp)(this.configuration).refresh(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Replace an invoices line items
     * @summary Replace an invoice\'s line items
     * @param {CustomerInvoiceV1ReplaceLineItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceV1Api
     */
    CustomerInvoiceV1Api.prototype.replaceLineItems = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceV1ApiFp)(this.configuration).replaceLineItems(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Update an invoice
     * @summary Update an invoice
     * @param {CustomerInvoiceV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceV1Api
     */
    CustomerInvoiceV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Void an invoice
     * @summary Void an invoice
     * @param {CustomerInvoiceV1VoidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceV1Api
     */
    CustomerInvoiceV1Api.prototype.void = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerInvoiceV1ApiFp)(this.configuration).void(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return CustomerInvoiceV1Api;
}(base_1.BaseAPI));
exports.CustomerInvoiceV1Api = CustomerInvoiceV1Api;
/**
 * CustomerPaymentV1Api - axios parameter creator
 * @export
 */
var CustomerPaymentV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Apply a customer payment
         * @param {string} id
         * @param {ApplyCustomerPaymentRequestDto} applyCustomerPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyCustomerPaymentRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('apply', 'id', id);
                    // verify required parameter 'applyCustomerPaymentRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('apply', 'applyCustomerPaymentRequestDto', applyCustomerPaymentRequestDto);
                    localVarPath = "/customer-payment/v1/{id}/apply"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(applyCustomerPaymentRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create a customer payment
         * @param {CreateCustomerPaymentRequestDto} createCustomerPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerPaymentRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createCustomerPaymentRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createCustomerPaymentRequestDto', createCustomerPaymentRequestDto);
                    localVarPath = "/customer-payment/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCustomerPaymentRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a customer payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delete', 'id', id);
                    localVarPath = "/customer-payment/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a customer payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/customer-payment/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a customer payment by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'referenceNumber' is not null or undefined
                    (0, common_1.assertParamExists)('getByReferenceNumber', 'referenceNumber', referenceNumber);
                    localVarPath = "/customer-payment/v1/reference-number/{referenceNumber}"
                        .replace("{".concat("referenceNumber", "}"), encodeURIComponent(String(referenceNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many customer payments
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerPaymentsFiltersRequestDto} [filters] Query filters for the customer payment
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer payments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/customer-payment/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Refresh a customer payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('refresh', 'id', id);
                    localVarPath = "/customer-payment/v1/{id}/refresh"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Unapply a customer payment application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('unapplyApplication', 'id', id);
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('unapplyApplication', 'applicationId', applicationId);
                    localVarPath = "/customer-payment/v1/{id}/applications/{applicationId}/unapply"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a customer payment
         * @param {string} id
         * @param {UpdateCustomerPaymentRequestDto} updateCustomerPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerPaymentRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'updateCustomerPaymentRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'updateCustomerPaymentRequestDto', updateCustomerPaymentRequestDto);
                    localVarPath = "/customer-payment/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCustomerPaymentRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CustomerPaymentV1ApiAxiosParamCreator = CustomerPaymentV1ApiAxiosParamCreator;
/**
 * CustomerPaymentV1Api - functional programming interface
 * @export
 */
var CustomerPaymentV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomerPaymentV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Apply a customer payment
         * @param {string} id
         * @param {ApplyCustomerPaymentRequestDto} applyCustomerPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyCustomerPaymentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apply(id, applyCustomerPaymentRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a customer payment
         * @param {CreateCustomerPaymentRequestDto} createCustomerPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerPaymentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createCustomerPaymentRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a customer payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a customer payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a customer payment by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getByReferenceNumber(referenceNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many customer payments
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerPaymentsFiltersRequestDto} [filters] Query filters for the customer payment
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer payments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Refresh a customer payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refresh(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Unapply a customer payment application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.unapplyApplication(id, applicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a customer payment
         * @param {string} id
         * @param {UpdateCustomerPaymentRequestDto} updateCustomerPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerPaymentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, updateCustomerPaymentRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CustomerPaymentV1ApiFp = CustomerPaymentV1ApiFp;
/**
 * CustomerPaymentV1Api - factory interface
 * @export
 */
var CustomerPaymentV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomerPaymentV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Apply a customer payment
         * @param {string} id
         * @param {ApplyCustomerPaymentRequestDto} applyCustomerPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyCustomerPaymentRequestDto, options) {
            return localVarFp.apply(id, applyCustomerPaymentRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a customer payment
         * @param {CreateCustomerPaymentRequestDto} createCustomerPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerPaymentRequestDto, options) {
            return localVarFp.create(createCustomerPaymentRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a customer payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return localVarFp.delete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a customer payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a customer payment by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return localVarFp.getByReferenceNumber(referenceNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many customer payments
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerPaymentsFiltersRequestDto} [filters] Query filters for the customer payment
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer payments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Refresh a customer payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return localVarFp.refresh(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Unapply a customer payment application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            return localVarFp.unapplyApplication(id, applicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a customer payment
         * @param {string} id
         * @param {UpdateCustomerPaymentRequestDto} updateCustomerPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerPaymentRequestDto, options) {
            return localVarFp.update(id, updateCustomerPaymentRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomerPaymentV1ApiFactory = CustomerPaymentV1ApiFactory;
/**
 * CustomerPaymentV1Api - object-oriented interface
 * @export
 * @class CustomerPaymentV1Api
 * @extends {BaseAPI}
 */
var CustomerPaymentV1Api = /** @class */ (function (_super) {
    __extends(CustomerPaymentV1Api, _super);
    function CustomerPaymentV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Apply a customer payment
     * @param {CustomerPaymentV1ApplyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentV1Api
     */
    CustomerPaymentV1Api.prototype.apply = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerPaymentV1ApiFp)(this.configuration).apply(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Create a customer payment
     * @param {CustomerPaymentV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentV1Api
     */
    CustomerPaymentV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerPaymentV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Delete a customer payment
     * @param {CustomerPaymentV1DeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentV1Api
     */
    CustomerPaymentV1Api.prototype.delete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerPaymentV1ApiFp)(this.configuration).delete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a customer payment
     * @param {CustomerPaymentV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentV1Api
     */
    CustomerPaymentV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerPaymentV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a customer payment by reference number
     * @param {CustomerPaymentV1GetByReferenceNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentV1Api
     */
    CustomerPaymentV1Api.prototype.getByReferenceNumber = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerPaymentV1ApiFp)(this.configuration).getByReferenceNumber(requestParameters.referenceNumber, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many customer payments
     * @param {CustomerPaymentV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentV1Api
     */
    CustomerPaymentV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerPaymentV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Refresh a customer payment
     * @param {CustomerPaymentV1RefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentV1Api
     */
    CustomerPaymentV1Api.prototype.refresh = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerPaymentV1ApiFp)(this.configuration).refresh(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Unapply a customer payment application
     * @param {CustomerPaymentV1UnapplyApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentV1Api
     */
    CustomerPaymentV1Api.prototype.unapplyApplication = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerPaymentV1ApiFp)(this.configuration).unapplyApplication(requestParameters.id, requestParameters.applicationId, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update a customer payment
     * @param {CustomerPaymentV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPaymentV1Api
     */
    CustomerPaymentV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerPaymentV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return CustomerPaymentV1Api;
}(base_1.BaseAPI));
exports.CustomerPaymentV1Api = CustomerPaymentV1Api;
/**
 * CustomerRefundApplicationV1Api - axios parameter creator
 * @export
 */
var CustomerRefundApplicationV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get many customer refund applications
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerRefundApplicationFiltersRequestDto} [filters] Query filters for the customer refund applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer refund applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/customer-refund-application/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CustomerRefundApplicationV1ApiAxiosParamCreator = CustomerRefundApplicationV1ApiAxiosParamCreator;
/**
 * CustomerRefundApplicationV1Api - functional programming interface
 * @export
 */
var CustomerRefundApplicationV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomerRefundApplicationV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get many customer refund applications
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerRefundApplicationFiltersRequestDto} [filters] Query filters for the customer refund applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer refund applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CustomerRefundApplicationV1ApiFp = CustomerRefundApplicationV1ApiFp;
/**
 * CustomerRefundApplicationV1Api - factory interface
 * @export
 */
var CustomerRefundApplicationV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomerRefundApplicationV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Get many customer refund applications
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerRefundApplicationFiltersRequestDto} [filters] Query filters for the customer refund applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer refund applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomerRefundApplicationV1ApiFactory = CustomerRefundApplicationV1ApiFactory;
/**
 * CustomerRefundApplicationV1Api - object-oriented interface
 * @export
 * @class CustomerRefundApplicationV1Api
 * @extends {BaseAPI}
 */
var CustomerRefundApplicationV1Api = /** @class */ (function (_super) {
    __extends(CustomerRefundApplicationV1Api, _super);
    function CustomerRefundApplicationV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get many customer refund applications
     * @param {CustomerRefundApplicationV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRefundApplicationV1Api
     */
    CustomerRefundApplicationV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerRefundApplicationV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return CustomerRefundApplicationV1Api;
}(base_1.BaseAPI));
exports.CustomerRefundApplicationV1Api = CustomerRefundApplicationV1Api;
/**
 * CustomerRefundV1Api - axios parameter creator
 * @export
 */
var CustomerRefundV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a refund
         * @param {CreateCustomerRefundRequestDto} createCustomerRefundRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerRefundRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createCustomerRefundRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createCustomerRefundRequestDto', createCustomerRefundRequestDto);
                    localVarPath = "/customer-refund/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCustomerRefundRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a customer refund
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delete', 'id', id);
                    localVarPath = "/customer-refund/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a refund
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/customer-refund/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a customer refund by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'referenceNumber' is not null or undefined
                    (0, common_1.assertParamExists)('getByReferenceNumber', 'referenceNumber', referenceNumber);
                    localVarPath = "/customer-refund/v1/reference-number/{referenceNumber}"
                        .replace("{".concat("referenceNumber", "}"), encodeURIComponent(String(referenceNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many customer refunds
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerRefundsFiltersRequestDto} [filters] Query filters for the customer refunds
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer refunds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/customer-refund/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Refresh a refund
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('refresh', 'id', id);
                    localVarPath = "/customer-refund/v1/{id}/refresh"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a refund
         * @param {string} id
         * @param {UpdateCustomerRefundRequestDto} updateCustomerRefundRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerRefundRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'updateCustomerRefundRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'updateCustomerRefundRequestDto', updateCustomerRefundRequestDto);
                    localVarPath = "/customer-refund/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCustomerRefundRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CustomerRefundV1ApiAxiosParamCreator = CustomerRefundV1ApiAxiosParamCreator;
/**
 * CustomerRefundV1Api - functional programming interface
 * @export
 */
var CustomerRefundV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomerRefundV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create a refund
         * @param {CreateCustomerRefundRequestDto} createCustomerRefundRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerRefundRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createCustomerRefundRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a customer refund
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a refund
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a customer refund by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getByReferenceNumber(referenceNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many customer refunds
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerRefundsFiltersRequestDto} [filters] Query filters for the customer refunds
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer refunds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Refresh a refund
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refresh(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a refund
         * @param {string} id
         * @param {UpdateCustomerRefundRequestDto} updateCustomerRefundRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerRefundRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, updateCustomerRefundRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CustomerRefundV1ApiFp = CustomerRefundV1ApiFp;
/**
 * CustomerRefundV1Api - factory interface
 * @export
 */
var CustomerRefundV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomerRefundV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Create a refund
         * @param {CreateCustomerRefundRequestDto} createCustomerRefundRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerRefundRequestDto, options) {
            return localVarFp.create(createCustomerRefundRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a customer refund
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return localVarFp.delete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a refund
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a customer refund by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return localVarFp.getByReferenceNumber(referenceNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many customer refunds
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomerRefundsFiltersRequestDto} [filters] Query filters for the customer refunds
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customer refunds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Refresh a refund
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return localVarFp.refresh(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a refund
         * @param {string} id
         * @param {UpdateCustomerRefundRequestDto} updateCustomerRefundRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerRefundRequestDto, options) {
            return localVarFp.update(id, updateCustomerRefundRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomerRefundV1ApiFactory = CustomerRefundV1ApiFactory;
/**
 * CustomerRefundV1Api - object-oriented interface
 * @export
 * @class CustomerRefundV1Api
 * @extends {BaseAPI}
 */
var CustomerRefundV1Api = /** @class */ (function (_super) {
    __extends(CustomerRefundV1Api, _super);
    function CustomerRefundV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a refund
     * @param {CustomerRefundV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRefundV1Api
     */
    CustomerRefundV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerRefundV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Delete a customer refund
     * @param {CustomerRefundV1DeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRefundV1Api
     */
    CustomerRefundV1Api.prototype.delete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerRefundV1ApiFp)(this.configuration).delete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a refund
     * @param {CustomerRefundV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRefundV1Api
     */
    CustomerRefundV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerRefundV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a customer refund by reference number
     * @param {CustomerRefundV1GetByReferenceNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRefundV1Api
     */
    CustomerRefundV1Api.prototype.getByReferenceNumber = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerRefundV1ApiFp)(this.configuration).getByReferenceNumber(requestParameters.referenceNumber, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many customer refunds
     * @param {CustomerRefundV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRefundV1Api
     */
    CustomerRefundV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerRefundV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Refresh a refund
     * @param {CustomerRefundV1RefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRefundV1Api
     */
    CustomerRefundV1Api.prototype.refresh = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerRefundV1ApiFp)(this.configuration).refresh(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update a refund
     * @param {CustomerRefundV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerRefundV1Api
     */
    CustomerRefundV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerRefundV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return CustomerRefundV1Api;
}(base_1.BaseAPI));
exports.CustomerRefundV1Api = CustomerRefundV1Api;
/**
 * CustomerV1Api - axios parameter creator
 * @export
 */
var CustomerV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a customer
         * @param {CreateCustomerRequestDto} createCustomerRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createCustomerRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createCustomerRequestDto', createCustomerRequestDto);
                    localVarPath = "/customer/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCustomerRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create terms for a customer
         * @param {string} id
         * @param {CreateCustomerTermRequestDto} createCustomerTermRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerms: function (id, createCustomerTermRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('createTerms', 'id', id);
                    // verify required parameter 'createCustomerTermRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('createTerms', 'createCustomerTermRequestDto', createCustomerTermRequestDto);
                    localVarPath = "/customer/v1/{id}/terms"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCustomerTermRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleted: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleted', 'id', id);
                    localVarPath = "/customer/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/customer/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many customers
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomersFiltersRequestDto} [filters] Query filters for the customers
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/customer/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Refresh a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('refresh', 'id', id);
                    localVarPath = "/customer/v1/{id}/refresh"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete terms for a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTerms: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('removeTerms', 'id', id);
                    localVarPath = "/customer/v1/{id}/terms"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a customer
         * @param {string} id
         * @param {UpdateCustomerRequestDto} updateCustomerRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'updateCustomerRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'updateCustomerRequestDto', updateCustomerRequestDto);
                    localVarPath = "/customer/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCustomerRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CustomerV1ApiAxiosParamCreator = CustomerV1ApiAxiosParamCreator;
/**
 * CustomerV1Api - functional programming interface
 * @export
 */
var CustomerV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CustomerV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create a customer
         * @param {CreateCustomerRequestDto} createCustomerRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createCustomerRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create terms for a customer
         * @param {string} id
         * @param {CreateCustomerTermRequestDto} createCustomerTermRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerms: function (id, createCustomerTermRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTerms(id, createCustomerTermRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleted: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleted(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many customers
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomersFiltersRequestDto} [filters] Query filters for the customers
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Refresh a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refresh(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete terms for a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTerms: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeTerms(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a customer
         * @param {string} id
         * @param {UpdateCustomerRequestDto} updateCustomerRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, updateCustomerRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CustomerV1ApiFp = CustomerV1ApiFp;
/**
 * CustomerV1Api - factory interface
 * @export
 */
var CustomerV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CustomerV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Create a customer
         * @param {CreateCustomerRequestDto} createCustomerRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createCustomerRequestDto, options) {
            return localVarFp.create(createCustomerRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create terms for a customer
         * @param {string} id
         * @param {CreateCustomerTermRequestDto} createCustomerTermRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerms: function (id, createCustomerTermRequestDto, options) {
            return localVarFp.createTerms(id, createCustomerTermRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleted: function (id, options) {
            return localVarFp.deleted(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many customers
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyCustomersFiltersRequestDto} [filters] Query filters for the customers
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the customers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Refresh a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return localVarFp.refresh(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete terms for a customer
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTerms: function (id, options) {
            return localVarFp.removeTerms(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a customer
         * @param {string} id
         * @param {UpdateCustomerRequestDto} updateCustomerRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateCustomerRequestDto, options) {
            return localVarFp.update(id, updateCustomerRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CustomerV1ApiFactory = CustomerV1ApiFactory;
/**
 * CustomerV1Api - object-oriented interface
 * @export
 * @class CustomerV1Api
 * @extends {BaseAPI}
 */
var CustomerV1Api = /** @class */ (function (_super) {
    __extends(CustomerV1Api, _super);
    function CustomerV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a customer
     * @param {CustomerV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerV1Api
     */
    CustomerV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Create terms for a customer
     * @param {CustomerV1CreateTermsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerV1Api
     */
    CustomerV1Api.prototype.createTerms = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerV1ApiFp)(this.configuration).createTerms(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Delete a customer
     * @param {CustomerV1DeletedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerV1Api
     */
    CustomerV1Api.prototype.deleted = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerV1ApiFp)(this.configuration).deleted(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a customer
     * @param {CustomerV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerV1Api
     */
    CustomerV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many customers
     * @param {CustomerV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerV1Api
     */
    CustomerV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Refresh a customer
     * @param {CustomerV1RefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerV1Api
     */
    CustomerV1Api.prototype.refresh = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerV1ApiFp)(this.configuration).refresh(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Delete terms for a customer
     * @param {CustomerV1RemoveTermsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerV1Api
     */
    CustomerV1Api.prototype.removeTerms = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerV1ApiFp)(this.configuration).removeTerms(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update a customer
     * @param {CustomerV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerV1Api
     */
    CustomerV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CustomerV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return CustomerV1Api;
}(base_1.BaseAPI));
exports.CustomerV1Api = CustomerV1Api;
/**
 * InvoiceLineItemsLegacyApi - axios parameter creator
 * @export
 */
var InvoiceLineItemsLegacyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Update legacy invoice line items
         * @param {PatchLineItemsBody} patchLineItemsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchLineItemsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'patchLineItemsBody' is not null or undefined
                    (0, common_1.assertParamExists)('updateMany', 'patchLineItemsBody', patchLineItemsBody);
                    localVarPath = "/legacy/line-items/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchLineItemsBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.InvoiceLineItemsLegacyApiAxiosParamCreator = InvoiceLineItemsLegacyApiAxiosParamCreator;
/**
 * InvoiceLineItemsLegacyApi - functional programming interface
 * @export
 */
var InvoiceLineItemsLegacyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.InvoiceLineItemsLegacyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Update legacy invoice line items
         * @param {PatchLineItemsBody} patchLineItemsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchLineItemsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateMany(patchLineItemsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.InvoiceLineItemsLegacyApiFp = InvoiceLineItemsLegacyApiFp;
/**
 * InvoiceLineItemsLegacyApi - factory interface
 * @export
 */
var InvoiceLineItemsLegacyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.InvoiceLineItemsLegacyApiFp)(configuration);
    return {
        /**
         *
         * @summary Update legacy invoice line items
         * @param {PatchLineItemsBody} patchLineItemsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchLineItemsBody, options) {
            return localVarFp.updateMany(patchLineItemsBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.InvoiceLineItemsLegacyApiFactory = InvoiceLineItemsLegacyApiFactory;
/**
 * InvoiceLineItemsLegacyApi - object-oriented interface
 * @export
 * @class InvoiceLineItemsLegacyApi
 * @extends {BaseAPI}
 */
var InvoiceLineItemsLegacyApi = /** @class */ (function (_super) {
    __extends(InvoiceLineItemsLegacyApi, _super);
    function InvoiceLineItemsLegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Update legacy invoice line items
     * @param {InvoiceLineItemsLegacyUpdateManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceLineItemsLegacyApi
     */
    InvoiceLineItemsLegacyApi.prototype.updateMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InvoiceLineItemsLegacyApiFp)(this.configuration).updateMany(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return InvoiceLineItemsLegacyApi;
}(base_1.BaseAPI));
exports.InvoiceLineItemsLegacyApi = InvoiceLineItemsLegacyApi;
/**
 * InvoicesLegacyApi - axios parameter creator
 * @export
 */
var InvoicesLegacyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create legacy invoice
         * @param {PostInvoicesBody} postInvoicesBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (postInvoicesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'postInvoicesBody' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'postInvoicesBody', postInvoicesBody);
                    localVarPath = "/legacy/invoices/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postInvoicesBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create bulk payments against invoices
         * @param {PostInvoicesReconcileBulkPaymentBody} postInvoicesReconcileBulkPaymentBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkReconciliation: function (postInvoicesReconcileBulkPaymentBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'postInvoicesReconcileBulkPaymentBody' is not null or undefined
                    (0, common_1.assertParamExists)('createBulkReconciliation', 'postInvoicesReconcileBulkPaymentBody', postInvoicesReconcileBulkPaymentBody);
                    localVarPath = "/legacy/invoices/v1/reconcile-bulk-payment";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postInvoicesReconcileBulkPaymentBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get legacy invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/legacy/invoices/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get aggregation
         * @param {string} contactId
         * @param {Array<string>} [invoiceIds]
         * @param {Array<string>} [excludedInvoiceIds]
         * @param {InvoiceDtoStatus} [statuses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregation: function (contactId, invoiceIds, excludedInvoiceIds, statuses, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'contactId' is not null or undefined
                    (0, common_1.assertParamExists)('getAggregation', 'contactId', contactId);
                    localVarPath = "/legacy/invoices/v1/aggregation";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (invoiceIds) {
                        localVarQueryParameter['invoiceIds'] = invoiceIds;
                    }
                    if (excludedInvoiceIds) {
                        localVarQueryParameter['excludedInvoiceIds'] = excludedInvoiceIds;
                    }
                    if (statuses !== undefined) {
                        localVarQueryParameter['statuses'] = statuses;
                    }
                    if (contactId !== undefined) {
                        localVarQueryParameter['contactId'] = contactId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many legacy invoices
         * @param {number} [createdBefore]
         * @param {number} [createdAfter]
         * @param {string} [sortOrder]
         * @param {string} [contactId]
         * @param {Array<string>} [invoiceIds]
         * @param {Array<string>} [excludedInvoiceIds]
         * @param {number} [limit]
         * @param {Array<string>} [netsuiteIds]
         * @param {Array<string>} [ownerIds]
         * @param {InvoiceOwnerType} [ownerType]
         * @param {string} [referenceNumber]
         * @param {number} [skip]
         * @param {InvoiceDtoStatus} [statuses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (createdBefore, createdAfter, sortOrder, contactId, invoiceIds, excludedInvoiceIds, limit, netsuiteIds, ownerIds, ownerType, referenceNumber, skip, statuses, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/legacy/invoices/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (createdBefore !== undefined) {
                        localVarQueryParameter['createdBefore'] = createdBefore;
                    }
                    if (createdAfter !== undefined) {
                        localVarQueryParameter['createdAfter'] = createdAfter;
                    }
                    if (sortOrder !== undefined) {
                        localVarQueryParameter['sortOrder'] = sortOrder;
                    }
                    if (contactId !== undefined) {
                        localVarQueryParameter['contactId'] = contactId;
                    }
                    if (invoiceIds) {
                        localVarQueryParameter['invoiceIds'] = invoiceIds;
                    }
                    if (excludedInvoiceIds) {
                        localVarQueryParameter['excludedInvoiceIds'] = excludedInvoiceIds;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (netsuiteIds) {
                        localVarQueryParameter['netsuiteIds'] = netsuiteIds;
                    }
                    if (ownerIds) {
                        localVarQueryParameter['ownerIds'] = ownerIds;
                    }
                    if (ownerType !== undefined) {
                        localVarQueryParameter['ownerType'] = ownerType;
                    }
                    if (referenceNumber !== undefined) {
                        localVarQueryParameter['referenceNumber'] = referenceNumber;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (statuses !== undefined) {
                        localVarQueryParameter['statuses'] = statuses;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update legacy invoice
         * @param {string} id
         * @param {PatchInvoiceBody} patchInvoiceBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, patchInvoiceBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'patchInvoiceBody' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'patchInvoiceBody', patchInvoiceBody);
                    localVarPath = "/legacy/invoices/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchInvoiceBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update legacy invoices
         * @param {PatchInvoicesBody} patchInvoicesBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchInvoicesBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'patchInvoicesBody' is not null or undefined
                    (0, common_1.assertParamExists)('updateMany', 'patchInvoicesBody', patchInvoicesBody);
                    localVarPath = "/legacy/invoices/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchInvoicesBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Upsert a revenue share adjustment entry
         * @param {string} id
         * @param {PatchInvoiceCreateRevenueShareEntry} patchInvoiceCreateRevenueShareEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertRevenueShare: function (id, patchInvoiceCreateRevenueShareEntry, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('upsertRevenueShare', 'id', id);
                    // verify required parameter 'patchInvoiceCreateRevenueShareEntry' is not null or undefined
                    (0, common_1.assertParamExists)('upsertRevenueShare', 'patchInvoiceCreateRevenueShareEntry', patchInvoiceCreateRevenueShareEntry);
                    localVarPath = "/legacy/invoices/v1/{id}/revenue-share"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchInvoiceCreateRevenueShareEntry, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.InvoicesLegacyApiAxiosParamCreator = InvoicesLegacyApiAxiosParamCreator;
/**
 * InvoicesLegacyApi - functional programming interface
 * @export
 */
var InvoicesLegacyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.InvoicesLegacyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create legacy invoice
         * @param {PostInvoicesBody} postInvoicesBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (postInvoicesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(postInvoicesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create bulk payments against invoices
         * @param {PostInvoicesReconcileBulkPaymentBody} postInvoicesReconcileBulkPaymentBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkReconciliation: function (postInvoicesReconcileBulkPaymentBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBulkReconciliation(postInvoicesReconcileBulkPaymentBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get legacy invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get aggregation
         * @param {string} contactId
         * @param {Array<string>} [invoiceIds]
         * @param {Array<string>} [excludedInvoiceIds]
         * @param {InvoiceDtoStatus} [statuses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregation: function (contactId, invoiceIds, excludedInvoiceIds, statuses, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAggregation(contactId, invoiceIds, excludedInvoiceIds, statuses, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many legacy invoices
         * @param {number} [createdBefore]
         * @param {number} [createdAfter]
         * @param {string} [sortOrder]
         * @param {string} [contactId]
         * @param {Array<string>} [invoiceIds]
         * @param {Array<string>} [excludedInvoiceIds]
         * @param {number} [limit]
         * @param {Array<string>} [netsuiteIds]
         * @param {Array<string>} [ownerIds]
         * @param {InvoiceOwnerType} [ownerType]
         * @param {string} [referenceNumber]
         * @param {number} [skip]
         * @param {InvoiceDtoStatus} [statuses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (createdBefore, createdAfter, sortOrder, contactId, invoiceIds, excludedInvoiceIds, limit, netsuiteIds, ownerIds, ownerType, referenceNumber, skip, statuses, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(createdBefore, createdAfter, sortOrder, contactId, invoiceIds, excludedInvoiceIds, limit, netsuiteIds, ownerIds, ownerType, referenceNumber, skip, statuses, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update legacy invoice
         * @param {string} id
         * @param {PatchInvoiceBody} patchInvoiceBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, patchInvoiceBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, patchInvoiceBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update legacy invoices
         * @param {PatchInvoicesBody} patchInvoicesBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchInvoicesBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateMany(patchInvoicesBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Upsert a revenue share adjustment entry
         * @param {string} id
         * @param {PatchInvoiceCreateRevenueShareEntry} patchInvoiceCreateRevenueShareEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertRevenueShare: function (id, patchInvoiceCreateRevenueShareEntry, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.upsertRevenueShare(id, patchInvoiceCreateRevenueShareEntry, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.InvoicesLegacyApiFp = InvoicesLegacyApiFp;
/**
 * InvoicesLegacyApi - factory interface
 * @export
 */
var InvoicesLegacyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.InvoicesLegacyApiFp)(configuration);
    return {
        /**
         *
         * @summary Create legacy invoice
         * @param {PostInvoicesBody} postInvoicesBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (postInvoicesBody, options) {
            return localVarFp.create(postInvoicesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create bulk payments against invoices
         * @param {PostInvoicesReconcileBulkPaymentBody} postInvoicesReconcileBulkPaymentBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkReconciliation: function (postInvoicesReconcileBulkPaymentBody, options) {
            return localVarFp.createBulkReconciliation(postInvoicesReconcileBulkPaymentBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get legacy invoice
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get aggregation
         * @param {string} contactId
         * @param {Array<string>} [invoiceIds]
         * @param {Array<string>} [excludedInvoiceIds]
         * @param {InvoiceDtoStatus} [statuses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregation: function (contactId, invoiceIds, excludedInvoiceIds, statuses, options) {
            return localVarFp.getAggregation(contactId, invoiceIds, excludedInvoiceIds, statuses, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many legacy invoices
         * @param {number} [createdBefore]
         * @param {number} [createdAfter]
         * @param {string} [sortOrder]
         * @param {string} [contactId]
         * @param {Array<string>} [invoiceIds]
         * @param {Array<string>} [excludedInvoiceIds]
         * @param {number} [limit]
         * @param {Array<string>} [netsuiteIds]
         * @param {Array<string>} [ownerIds]
         * @param {InvoiceOwnerType} [ownerType]
         * @param {string} [referenceNumber]
         * @param {number} [skip]
         * @param {InvoiceDtoStatus} [statuses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (createdBefore, createdAfter, sortOrder, contactId, invoiceIds, excludedInvoiceIds, limit, netsuiteIds, ownerIds, ownerType, referenceNumber, skip, statuses, options) {
            return localVarFp.getMany(createdBefore, createdAfter, sortOrder, contactId, invoiceIds, excludedInvoiceIds, limit, netsuiteIds, ownerIds, ownerType, referenceNumber, skip, statuses, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update legacy invoice
         * @param {string} id
         * @param {PatchInvoiceBody} patchInvoiceBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, patchInvoiceBody, options) {
            return localVarFp.update(id, patchInvoiceBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update legacy invoices
         * @param {PatchInvoicesBody} patchInvoicesBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchInvoicesBody, options) {
            return localVarFp.updateMany(patchInvoicesBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upsert a revenue share adjustment entry
         * @param {string} id
         * @param {PatchInvoiceCreateRevenueShareEntry} patchInvoiceCreateRevenueShareEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertRevenueShare: function (id, patchInvoiceCreateRevenueShareEntry, options) {
            return localVarFp.upsertRevenueShare(id, patchInvoiceCreateRevenueShareEntry, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.InvoicesLegacyApiFactory = InvoicesLegacyApiFactory;
/**
 * InvoicesLegacyApi - object-oriented interface
 * @export
 * @class InvoicesLegacyApi
 * @extends {BaseAPI}
 */
var InvoicesLegacyApi = /** @class */ (function (_super) {
    __extends(InvoicesLegacyApi, _super);
    function InvoicesLegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create legacy invoice
     * @param {InvoicesLegacyCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesLegacyApi
     */
    InvoicesLegacyApi.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InvoicesLegacyApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Create bulk payments against invoices
     * @param {InvoicesLegacyCreateBulkReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesLegacyApi
     */
    InvoicesLegacyApi.prototype.createBulkReconciliation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InvoicesLegacyApiFp)(this.configuration).createBulkReconciliation(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get legacy invoice
     * @param {InvoicesLegacyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesLegacyApi
     */
    InvoicesLegacyApi.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InvoicesLegacyApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get aggregation
     * @param {InvoicesLegacyGetAggregationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesLegacyApi
     */
    InvoicesLegacyApi.prototype.getAggregation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InvoicesLegacyApiFp)(this.configuration).getAggregation(requestParameters.contactId, requestParameters.invoiceIds, requestParameters.excludedInvoiceIds, requestParameters.statuses, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many legacy invoices
     * @param {InvoicesLegacyGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesLegacyApi
     */
    InvoicesLegacyApi.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.InvoicesLegacyApiFp)(this.configuration).getMany(requestParameters.createdBefore, requestParameters.createdAfter, requestParameters.sortOrder, requestParameters.contactId, requestParameters.invoiceIds, requestParameters.excludedInvoiceIds, requestParameters.limit, requestParameters.netsuiteIds, requestParameters.ownerIds, requestParameters.ownerType, requestParameters.referenceNumber, requestParameters.skip, requestParameters.statuses, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update legacy invoice
     * @param {InvoicesLegacyUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesLegacyApi
     */
    InvoicesLegacyApi.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InvoicesLegacyApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update legacy invoices
     * @param {InvoicesLegacyUpdateManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesLegacyApi
     */
    InvoicesLegacyApi.prototype.updateMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InvoicesLegacyApiFp)(this.configuration).updateMany(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Upsert a revenue share adjustment entry
     * @param {InvoicesLegacyUpsertRevenueShareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesLegacyApi
     */
    InvoicesLegacyApi.prototype.upsertRevenueShare = function (requestParameters, options) {
        var _this = this;
        return (0, exports.InvoicesLegacyApiFp)(this.configuration).upsertRevenueShare(requestParameters.id, requestParameters.patchInvoiceCreateRevenueShareEntry, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return InvoicesLegacyApi;
}(base_1.BaseAPI));
exports.InvoicesLegacyApi = InvoicesLegacyApi;
/**
 * ItemV1Api - axios parameter creator
 * @export
 */
var ItemV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create an item
         * @param {CreateItemRequestDto} createItemRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createItemRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createItemRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createItemRequestDto', createItemRequestDto);
                    localVarPath = "/item/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createItemRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete an item
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delete', 'id', id);
                    localVarPath = "/item/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get an item
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/item/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many items
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyItemsFiltersRequestDto} [filters] Query filters for the customers
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/item/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update an item
         * @param {string} id
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'body', body);
                    localVarPath = "/item/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ItemV1ApiAxiosParamCreator = ItemV1ApiAxiosParamCreator;
/**
 * ItemV1Api - functional programming interface
 * @export
 */
var ItemV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ItemV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create an item
         * @param {CreateItemRequestDto} createItemRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createItemRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createItemRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an item
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get an item
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many items
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyItemsFiltersRequestDto} [filters] Query filters for the customers
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an item
         * @param {string} id
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ItemV1ApiFp = ItemV1ApiFp;
/**
 * ItemV1Api - factory interface
 * @export
 */
var ItemV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ItemV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Create an item
         * @param {CreateItemRequestDto} createItemRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createItemRequestDto, options) {
            return localVarFp.create(createItemRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an item
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return localVarFp.delete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get an item
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many items
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyItemsFiltersRequestDto} [filters] Query filters for the customers
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an item
         * @param {string} id
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, body, options) {
            return localVarFp.update(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ItemV1ApiFactory = ItemV1ApiFactory;
/**
 * ItemV1Api - object-oriented interface
 * @export
 * @class ItemV1Api
 * @extends {BaseAPI}
 */
var ItemV1Api = /** @class */ (function (_super) {
    __extends(ItemV1Api, _super);
    function ItemV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create an item
     * @param {ItemV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemV1Api
     */
    ItemV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ItemV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Delete an item
     * @param {ItemV1DeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemV1Api
     */
    ItemV1Api.prototype.delete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ItemV1ApiFp)(this.configuration).delete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get an item
     * @param {ItemV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemV1Api
     */
    ItemV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ItemV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many items
     * @param {ItemV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemV1Api
     */
    ItemV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ItemV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update an item
     * @param {ItemV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ItemV1Api
     */
    ItemV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ItemV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return ItemV1Api;
}(base_1.BaseAPI));
exports.ItemV1Api = ItemV1Api;
/**
 * NetSuiteLegacyApi - axios parameter creator
 * @export
 */
var NetSuiteLegacyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Hard update a legacy contact with netsuite sync data
         * @param {PatchNetsuiteFieldsBody} patchNetsuiteFieldsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardUpdate: function (patchNetsuiteFieldsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'patchNetsuiteFieldsBody' is not null or undefined
                    (0, common_1.assertParamExists)('hardUpdate', 'patchNetsuiteFieldsBody', patchNetsuiteFieldsBody);
                    localVarPath = "/legacy/netsuite/v1/hard-update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchNetsuiteFieldsBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.NetSuiteLegacyApiAxiosParamCreator = NetSuiteLegacyApiAxiosParamCreator;
/**
 * NetSuiteLegacyApi - functional programming interface
 * @export
 */
var NetSuiteLegacyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.NetSuiteLegacyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Hard update a legacy contact with netsuite sync data
         * @param {PatchNetsuiteFieldsBody} patchNetsuiteFieldsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardUpdate: function (patchNetsuiteFieldsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.hardUpdate(patchNetsuiteFieldsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.NetSuiteLegacyApiFp = NetSuiteLegacyApiFp;
/**
 * NetSuiteLegacyApi - factory interface
 * @export
 */
var NetSuiteLegacyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.NetSuiteLegacyApiFp)(configuration);
    return {
        /**
         *
         * @summary Hard update a legacy contact with netsuite sync data
         * @param {PatchNetsuiteFieldsBody} patchNetsuiteFieldsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardUpdate: function (patchNetsuiteFieldsBody, options) {
            return localVarFp.hardUpdate(patchNetsuiteFieldsBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.NetSuiteLegacyApiFactory = NetSuiteLegacyApiFactory;
/**
 * NetSuiteLegacyApi - object-oriented interface
 * @export
 * @class NetSuiteLegacyApi
 * @extends {BaseAPI}
 */
var NetSuiteLegacyApi = /** @class */ (function (_super) {
    __extends(NetSuiteLegacyApi, _super);
    function NetSuiteLegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Hard update a legacy contact with netsuite sync data
     * @param {NetSuiteLegacyHardUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetSuiteLegacyApi
     */
    NetSuiteLegacyApi.prototype.hardUpdate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.NetSuiteLegacyApiFp)(this.configuration).hardUpdate(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return NetSuiteLegacyApi;
}(base_1.BaseAPI));
exports.NetSuiteLegacyApi = NetSuiteLegacyApi;
/**
 * PaymentsLegacyApi - axios parameter creator
 * @export
 */
var PaymentsLegacyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create many legacy payments
         * @param {PostPaymentsBody} postPaymentsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postPaymentsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'postPaymentsBody' is not null or undefined
                    (0, common_1.assertParamExists)('createMany', 'postPaymentsBody', postPaymentsBody);
                    localVarPath = "/legacy/payments/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postPaymentsBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a legacy payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/legacy/payments/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many legacy payments
         * @param {Array<string>} [ids]
         * @param {boolean} [hasNetSuiteId]
         * @param {string} [invoiceId]
         * @param {Array<string>} [netsuiteIds]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [stripeChargeId]
         * @param {string} [bulkReconcileRequestId]
         * @param {PaymentStatus} [statuses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (ids, hasNetSuiteId, invoiceId, netsuiteIds, limit, skip, stripeChargeId, bulkReconcileRequestId, statuses, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/legacy/payments/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ids) {
                        localVarQueryParameter['ids'] = ids;
                    }
                    if (hasNetSuiteId !== undefined) {
                        localVarQueryParameter['hasNetSuiteId'] = hasNetSuiteId;
                    }
                    if (invoiceId !== undefined) {
                        localVarQueryParameter['invoiceId'] = invoiceId;
                    }
                    if (netsuiteIds) {
                        localVarQueryParameter['netsuiteIds'] = netsuiteIds;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (stripeChargeId !== undefined) {
                        localVarQueryParameter['stripeChargeId'] = stripeChargeId;
                    }
                    if (bulkReconcileRequestId !== undefined) {
                        localVarQueryParameter['bulkReconcileRequestId'] = bulkReconcileRequestId;
                    }
                    if (statuses !== undefined) {
                        localVarQueryParameter['statuses'] = statuses;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update many legacy payments
         * @param {PatchPaymentsBody} patchPaymentsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchPaymentsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'patchPaymentsBody' is not null or undefined
                    (0, common_1.assertParamExists)('updateMany', 'patchPaymentsBody', patchPaymentsBody);
                    localVarPath = "/legacy/payments/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchPaymentsBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PaymentsLegacyApiAxiosParamCreator = PaymentsLegacyApiAxiosParamCreator;
/**
 * PaymentsLegacyApi - functional programming interface
 * @export
 */
var PaymentsLegacyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PaymentsLegacyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create many legacy payments
         * @param {PostPaymentsBody} postPaymentsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postPaymentsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createMany(postPaymentsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a legacy payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many legacy payments
         * @param {Array<string>} [ids]
         * @param {boolean} [hasNetSuiteId]
         * @param {string} [invoiceId]
         * @param {Array<string>} [netsuiteIds]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [stripeChargeId]
         * @param {string} [bulkReconcileRequestId]
         * @param {PaymentStatus} [statuses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (ids, hasNetSuiteId, invoiceId, netsuiteIds, limit, skip, stripeChargeId, bulkReconcileRequestId, statuses, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(ids, hasNetSuiteId, invoiceId, netsuiteIds, limit, skip, stripeChargeId, bulkReconcileRequestId, statuses, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update many legacy payments
         * @param {PatchPaymentsBody} patchPaymentsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchPaymentsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateMany(patchPaymentsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PaymentsLegacyApiFp = PaymentsLegacyApiFp;
/**
 * PaymentsLegacyApi - factory interface
 * @export
 */
var PaymentsLegacyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PaymentsLegacyApiFp)(configuration);
    return {
        /**
         *
         * @summary Create many legacy payments
         * @param {PostPaymentsBody} postPaymentsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postPaymentsBody, options) {
            return localVarFp.createMany(postPaymentsBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a legacy payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many legacy payments
         * @param {Array<string>} [ids]
         * @param {boolean} [hasNetSuiteId]
         * @param {string} [invoiceId]
         * @param {Array<string>} [netsuiteIds]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [stripeChargeId]
         * @param {string} [bulkReconcileRequestId]
         * @param {PaymentStatus} [statuses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (ids, hasNetSuiteId, invoiceId, netsuiteIds, limit, skip, stripeChargeId, bulkReconcileRequestId, statuses, options) {
            return localVarFp.getMany(ids, hasNetSuiteId, invoiceId, netsuiteIds, limit, skip, stripeChargeId, bulkReconcileRequestId, statuses, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update many legacy payments
         * @param {PatchPaymentsBody} patchPaymentsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchPaymentsBody, options) {
            return localVarFp.updateMany(patchPaymentsBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PaymentsLegacyApiFactory = PaymentsLegacyApiFactory;
/**
 * PaymentsLegacyApi - object-oriented interface
 * @export
 * @class PaymentsLegacyApi
 * @extends {BaseAPI}
 */
var PaymentsLegacyApi = /** @class */ (function (_super) {
    __extends(PaymentsLegacyApi, _super);
    function PaymentsLegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create many legacy payments
     * @param {PaymentsLegacyCreateManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsLegacyApi
     */
    PaymentsLegacyApi.prototype.createMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PaymentsLegacyApiFp)(this.configuration).createMany(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a legacy payment
     * @param {PaymentsLegacyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsLegacyApi
     */
    PaymentsLegacyApi.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PaymentsLegacyApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many legacy payments
     * @param {PaymentsLegacyGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsLegacyApi
     */
    PaymentsLegacyApi.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PaymentsLegacyApiFp)(this.configuration).getMany(requestParameters.ids, requestParameters.hasNetSuiteId, requestParameters.invoiceId, requestParameters.netsuiteIds, requestParameters.limit, requestParameters.skip, requestParameters.stripeChargeId, requestParameters.bulkReconcileRequestId, requestParameters.statuses, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update many legacy payments
     * @param {PaymentsLegacyUpdateManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsLegacyApi
     */
    PaymentsLegacyApi.prototype.updateMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PaymentsLegacyApiFp)(this.configuration).updateMany(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return PaymentsLegacyApi;
}(base_1.BaseAPI));
exports.PaymentsLegacyApi = PaymentsLegacyApi;
/**
 * PayoutsLegacyApi - axios parameter creator
 * @export
 */
var PayoutsLegacyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create many legacy payout
         * @param {PostPayoutsBody} postPayoutsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postPayoutsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'postPayoutsBody' is not null or undefined
                    (0, common_1.assertParamExists)('createMany', 'postPayoutsBody', postPayoutsBody);
                    localVarPath = "/legacy/payouts/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postPayoutsBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a legacy payout
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/legacy/payouts/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many legacy payout
         * @param {number} [createdAfter]
         * @param {number} [createdBefore]
         * @param {Array<string>} [billIds]
         * @param {number} [limit]
         * @param {Array<string>} [netsuiteIds]
         * @param {number} [skip]
         * @param {Array<string>} [stripePayoutIds]
         * @param {Array<string>} [stripeTransferIds]
         * @param {Array<string>} [userFirebaseKeys]
         * @param {Array<any>} [statuses]
         * @param {boolean} [hasNetSuiteId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (createdAfter, createdBefore, billIds, limit, netsuiteIds, skip, stripePayoutIds, stripeTransferIds, userFirebaseKeys, statuses, hasNetSuiteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/legacy/payouts/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (createdAfter !== undefined) {
                        localVarQueryParameter['createdAfter'] = createdAfter;
                    }
                    if (createdBefore !== undefined) {
                        localVarQueryParameter['createdBefore'] = createdBefore;
                    }
                    if (billIds) {
                        localVarQueryParameter['billIds'] = billIds;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (netsuiteIds) {
                        localVarQueryParameter['netsuiteIds'] = netsuiteIds;
                    }
                    if (skip !== undefined) {
                        localVarQueryParameter['skip'] = skip;
                    }
                    if (stripePayoutIds) {
                        localVarQueryParameter['stripePayoutIds'] = stripePayoutIds;
                    }
                    if (stripeTransferIds) {
                        localVarQueryParameter['stripeTransferIds'] = stripeTransferIds;
                    }
                    if (userFirebaseKeys) {
                        localVarQueryParameter['userFirebaseKeys'] = userFirebaseKeys;
                    }
                    if (statuses) {
                        localVarQueryParameter['statuses'] = statuses;
                    }
                    if (hasNetSuiteId !== undefined) {
                        localVarQueryParameter['hasNetSuiteId'] = hasNetSuiteId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update many legacy payout
         * @param {PatchPayoutsBody} patchPayoutsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchPayoutsBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'patchPayoutsBody' is not null or undefined
                    (0, common_1.assertParamExists)('updateMany', 'patchPayoutsBody', patchPayoutsBody);
                    localVarPath = "/legacy/payouts/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchPayoutsBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PayoutsLegacyApiAxiosParamCreator = PayoutsLegacyApiAxiosParamCreator;
/**
 * PayoutsLegacyApi - functional programming interface
 * @export
 */
var PayoutsLegacyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PayoutsLegacyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create many legacy payout
         * @param {PostPayoutsBody} postPayoutsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postPayoutsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createMany(postPayoutsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a legacy payout
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many legacy payout
         * @param {number} [createdAfter]
         * @param {number} [createdBefore]
         * @param {Array<string>} [billIds]
         * @param {number} [limit]
         * @param {Array<string>} [netsuiteIds]
         * @param {number} [skip]
         * @param {Array<string>} [stripePayoutIds]
         * @param {Array<string>} [stripeTransferIds]
         * @param {Array<string>} [userFirebaseKeys]
         * @param {Array<any>} [statuses]
         * @param {boolean} [hasNetSuiteId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (createdAfter, createdBefore, billIds, limit, netsuiteIds, skip, stripePayoutIds, stripeTransferIds, userFirebaseKeys, statuses, hasNetSuiteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(createdAfter, createdBefore, billIds, limit, netsuiteIds, skip, stripePayoutIds, stripeTransferIds, userFirebaseKeys, statuses, hasNetSuiteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update many legacy payout
         * @param {PatchPayoutsBody} patchPayoutsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchPayoutsBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateMany(patchPayoutsBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PayoutsLegacyApiFp = PayoutsLegacyApiFp;
/**
 * PayoutsLegacyApi - factory interface
 * @export
 */
var PayoutsLegacyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PayoutsLegacyApiFp)(configuration);
    return {
        /**
         *
         * @summary Create many legacy payout
         * @param {PostPayoutsBody} postPayoutsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMany: function (postPayoutsBody, options) {
            return localVarFp.createMany(postPayoutsBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a legacy payout
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many legacy payout
         * @param {number} [createdAfter]
         * @param {number} [createdBefore]
         * @param {Array<string>} [billIds]
         * @param {number} [limit]
         * @param {Array<string>} [netsuiteIds]
         * @param {number} [skip]
         * @param {Array<string>} [stripePayoutIds]
         * @param {Array<string>} [stripeTransferIds]
         * @param {Array<string>} [userFirebaseKeys]
         * @param {Array<any>} [statuses]
         * @param {boolean} [hasNetSuiteId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (createdAfter, createdBefore, billIds, limit, netsuiteIds, skip, stripePayoutIds, stripeTransferIds, userFirebaseKeys, statuses, hasNetSuiteId, options) {
            return localVarFp.getMany(createdAfter, createdBefore, billIds, limit, netsuiteIds, skip, stripePayoutIds, stripeTransferIds, userFirebaseKeys, statuses, hasNetSuiteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update many legacy payout
         * @param {PatchPayoutsBody} patchPayoutsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMany: function (patchPayoutsBody, options) {
            return localVarFp.updateMany(patchPayoutsBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PayoutsLegacyApiFactory = PayoutsLegacyApiFactory;
/**
 * PayoutsLegacyApi - object-oriented interface
 * @export
 * @class PayoutsLegacyApi
 * @extends {BaseAPI}
 */
var PayoutsLegacyApi = /** @class */ (function (_super) {
    __extends(PayoutsLegacyApi, _super);
    function PayoutsLegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create many legacy payout
     * @param {PayoutsLegacyCreateManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsLegacyApi
     */
    PayoutsLegacyApi.prototype.createMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PayoutsLegacyApiFp)(this.configuration).createMany(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a legacy payout
     * @param {PayoutsLegacyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsLegacyApi
     */
    PayoutsLegacyApi.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PayoutsLegacyApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many legacy payout
     * @param {PayoutsLegacyGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsLegacyApi
     */
    PayoutsLegacyApi.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.PayoutsLegacyApiFp)(this.configuration).getMany(requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.billIds, requestParameters.limit, requestParameters.netsuiteIds, requestParameters.skip, requestParameters.stripePayoutIds, requestParameters.stripeTransferIds, requestParameters.userFirebaseKeys, requestParameters.statuses, requestParameters.hasNetSuiteId, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update many legacy payout
     * @param {PayoutsLegacyUpdateManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayoutsLegacyApi
     */
    PayoutsLegacyApi.prototype.updateMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PayoutsLegacyApiFp)(this.configuration).updateMany(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return PayoutsLegacyApi;
}(base_1.BaseAPI));
exports.PayoutsLegacyApi = PayoutsLegacyApi;
/**
 * ServiceV1Api - axios parameter creator
 * @export
 */
var ServiceV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get a financial overview for a service
         * @param {string} serviceId The id of the service
         * @param {ServiceType} serviceType The type of service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceOverview: function (serviceId, serviceType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serviceId' is not null or undefined
                    (0, common_1.assertParamExists)('getServiceOverview', 'serviceId', serviceId);
                    // verify required parameter 'serviceType' is not null or undefined
                    (0, common_1.assertParamExists)('getServiceOverview', 'serviceType', serviceType);
                    localVarPath = "/service/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (serviceId !== undefined) {
                        localVarQueryParameter['serviceId'] = serviceId;
                    }
                    if (serviceType !== undefined) {
                        localVarQueryParameter['serviceType'] = serviceType;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ServiceV1ApiAxiosParamCreator = ServiceV1ApiAxiosParamCreator;
/**
 * ServiceV1Api - functional programming interface
 * @export
 */
var ServiceV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ServiceV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get a financial overview for a service
         * @param {string} serviceId The id of the service
         * @param {ServiceType} serviceType The type of service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceOverview: function (serviceId, serviceType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getServiceOverview(serviceId, serviceType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ServiceV1ApiFp = ServiceV1ApiFp;
/**
 * ServiceV1Api - factory interface
 * @export
 */
var ServiceV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ServiceV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Get a financial overview for a service
         * @param {string} serviceId The id of the service
         * @param {ServiceType} serviceType The type of service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceOverview: function (serviceId, serviceType, options) {
            return localVarFp.getServiceOverview(serviceId, serviceType, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ServiceV1ApiFactory = ServiceV1ApiFactory;
/**
 * ServiceV1Api - object-oriented interface
 * @export
 * @class ServiceV1Api
 * @extends {BaseAPI}
 */
var ServiceV1Api = /** @class */ (function (_super) {
    __extends(ServiceV1Api, _super);
    function ServiceV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get a financial overview for a service
     * @param {ServiceV1GetServiceOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceV1Api
     */
    ServiceV1Api.prototype.getServiceOverview = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ServiceV1ApiFp)(this.configuration).getServiceOverview(requestParameters.serviceId, requestParameters.serviceType, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return ServiceV1Api;
}(base_1.BaseAPI));
exports.ServiceV1Api = ServiceV1Api;
/**
 * ShipmentsLegacyApi - axios parameter creator
 * @export
 */
var ShipmentsLegacyApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get many legacy shipment financial info
         * @param {Array<string>} shipmentIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (shipmentIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shipmentIds' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'shipmentIds', shipmentIds);
                    localVarPath = "/legacy/shipments/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (shipmentIds) {
                        localVarQueryParameter['shipmentIds'] = shipmentIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ShipmentsLegacyApiAxiosParamCreator = ShipmentsLegacyApiAxiosParamCreator;
/**
 * ShipmentsLegacyApi - functional programming interface
 * @export
 */
var ShipmentsLegacyApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShipmentsLegacyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get many legacy shipment financial info
         * @param {Array<string>} shipmentIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (shipmentIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(shipmentIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShipmentsLegacyApiFp = ShipmentsLegacyApiFp;
/**
 * ShipmentsLegacyApi - factory interface
 * @export
 */
var ShipmentsLegacyApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShipmentsLegacyApiFp)(configuration);
    return {
        /**
         *
         * @summary Get many legacy shipment financial info
         * @param {Array<string>} shipmentIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (shipmentIds, options) {
            return localVarFp.getMany(shipmentIds, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShipmentsLegacyApiFactory = ShipmentsLegacyApiFactory;
/**
 * ShipmentsLegacyApi - object-oriented interface
 * @export
 * @class ShipmentsLegacyApi
 * @extends {BaseAPI}
 */
var ShipmentsLegacyApi = /** @class */ (function (_super) {
    __extends(ShipmentsLegacyApi, _super);
    function ShipmentsLegacyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get many legacy shipment financial info
     * @param {ShipmentsLegacyGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsLegacyApi
     */
    ShipmentsLegacyApi.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ShipmentsLegacyApiFp)(this.configuration).getMany(requestParameters.shipmentIds, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return ShipmentsLegacyApi;
}(base_1.BaseAPI));
exports.ShipmentsLegacyApi = ShipmentsLegacyApi;
/**
 * SubsidiaryV1Api - axios parameter creator
 * @export
 */
var SubsidiaryV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a subsidiary
         * @param {CreateSubsidiaryRequestDto} createSubsidiaryRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createSubsidiaryRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createSubsidiaryRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createSubsidiaryRequestDto', createSubsidiaryRequestDto);
                    localVarPath = "/subsidiary/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSubsidiaryRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a subsidiary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleted: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleted', 'id', id);
                    localVarPath = "/subsidiary/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a subsidiary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/subsidiary/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a subsidiary
         * @param {string} id
         * @param {UpdateSubsidiaryRequestDto} updateSubsidiaryRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateSubsidiaryRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'updateSubsidiaryRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'updateSubsidiaryRequestDto', updateSubsidiaryRequestDto);
                    localVarPath = "/subsidiary/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSubsidiaryRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SubsidiaryV1ApiAxiosParamCreator = SubsidiaryV1ApiAxiosParamCreator;
/**
 * SubsidiaryV1Api - functional programming interface
 * @export
 */
var SubsidiaryV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SubsidiaryV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create a subsidiary
         * @param {CreateSubsidiaryRequestDto} createSubsidiaryRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createSubsidiaryRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createSubsidiaryRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a subsidiary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleted: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleted(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a subsidiary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a subsidiary
         * @param {string} id
         * @param {UpdateSubsidiaryRequestDto} updateSubsidiaryRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateSubsidiaryRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, updateSubsidiaryRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SubsidiaryV1ApiFp = SubsidiaryV1ApiFp;
/**
 * SubsidiaryV1Api - factory interface
 * @export
 */
var SubsidiaryV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SubsidiaryV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Create a subsidiary
         * @param {CreateSubsidiaryRequestDto} createSubsidiaryRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createSubsidiaryRequestDto, options) {
            return localVarFp.create(createSubsidiaryRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a subsidiary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleted: function (id, options) {
            return localVarFp.deleted(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a subsidiary
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a subsidiary
         * @param {string} id
         * @param {UpdateSubsidiaryRequestDto} updateSubsidiaryRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateSubsidiaryRequestDto, options) {
            return localVarFp.update(id, updateSubsidiaryRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SubsidiaryV1ApiFactory = SubsidiaryV1ApiFactory;
/**
 * SubsidiaryV1Api - object-oriented interface
 * @export
 * @class SubsidiaryV1Api
 * @extends {BaseAPI}
 */
var SubsidiaryV1Api = /** @class */ (function (_super) {
    __extends(SubsidiaryV1Api, _super);
    function SubsidiaryV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a subsidiary
     * @param {SubsidiaryV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubsidiaryV1Api
     */
    SubsidiaryV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubsidiaryV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Delete a subsidiary
     * @param {SubsidiaryV1DeletedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubsidiaryV1Api
     */
    SubsidiaryV1Api.prototype.deleted = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubsidiaryV1ApiFp)(this.configuration).deleted(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a subsidiary
     * @param {SubsidiaryV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubsidiaryV1Api
     */
    SubsidiaryV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubsidiaryV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update a subsidiary
     * @param {SubsidiaryV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubsidiaryV1Api
     */
    SubsidiaryV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubsidiaryV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return SubsidiaryV1Api;
}(base_1.BaseAPI));
exports.SubsidiaryV1Api = SubsidiaryV1Api;
/**
 * TermV1Api - axios parameter creator
 * @export
 */
var TermV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a term
         * @param {CreateTermRequestDto} createTermRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createTermRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createTermRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createTermRequestDto', createTermRequestDto);
                    localVarPath = "/term/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTermRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a term
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delete', 'id', id);
                    localVarPath = "/term/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a term
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/term/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many terms
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyTermFiltersRequestDto} [filters] Query filters for the customers
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the terms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/term/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a term
         * @param {string} id
         * @param {UpdateTermRequestDto} updateTermRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateTermRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'updateTermRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'updateTermRequestDto', updateTermRequestDto);
                    localVarPath = "/term/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateTermRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TermV1ApiAxiosParamCreator = TermV1ApiAxiosParamCreator;
/**
 * TermV1Api - functional programming interface
 * @export
 */
var TermV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TermV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create a term
         * @param {CreateTermRequestDto} createTermRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createTermRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createTermRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a term
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a term
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many terms
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyTermFiltersRequestDto} [filters] Query filters for the customers
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the terms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a term
         * @param {string} id
         * @param {UpdateTermRequestDto} updateTermRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateTermRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, updateTermRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TermV1ApiFp = TermV1ApiFp;
/**
 * TermV1Api - factory interface
 * @export
 */
var TermV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TermV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Create a term
         * @param {CreateTermRequestDto} createTermRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createTermRequestDto, options) {
            return localVarFp.create(createTermRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a term
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return localVarFp.delete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a term
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many terms
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyTermFiltersRequestDto} [filters] Query filters for the customers
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the terms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a term
         * @param {string} id
         * @param {UpdateTermRequestDto} updateTermRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateTermRequestDto, options) {
            return localVarFp.update(id, updateTermRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TermV1ApiFactory = TermV1ApiFactory;
/**
 * TermV1Api - object-oriented interface
 * @export
 * @class TermV1Api
 * @extends {BaseAPI}
 */
var TermV1Api = /** @class */ (function (_super) {
    __extends(TermV1Api, _super);
    function TermV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a term
     * @param {TermV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermV1Api
     */
    TermV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TermV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Delete a term
     * @param {TermV1DeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermV1Api
     */
    TermV1Api.prototype.delete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TermV1ApiFp)(this.configuration).delete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a term
     * @param {TermV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermV1Api
     */
    TermV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TermV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many terms
     * @param {TermV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermV1Api
     */
    TermV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TermV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update a term
     * @param {TermV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermV1Api
     */
    TermV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TermV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return TermV1Api;
}(base_1.BaseAPI));
exports.TermV1Api = TermV1Api;
/**
 * VendorBillApplicationV1Api - axios parameter creator
 * @export
 */
var VendorBillApplicationV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete a vendor bill application
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delete', 'id', id);
                    localVarPath = "/vendor-bill-application/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many vendor bill applications
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorBillApplicationFiltersRequestDto} [filters] Query filters for the vendor bill applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/vendor-bill-application/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.VendorBillApplicationV1ApiAxiosParamCreator = VendorBillApplicationV1ApiAxiosParamCreator;
/**
 * VendorBillApplicationV1Api - functional programming interface
 * @export
 */
var VendorBillApplicationV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VendorBillApplicationV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete a vendor bill application
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many vendor bill applications
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorBillApplicationFiltersRequestDto} [filters] Query filters for the vendor bill applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VendorBillApplicationV1ApiFp = VendorBillApplicationV1ApiFp;
/**
 * VendorBillApplicationV1Api - factory interface
 * @export
 */
var VendorBillApplicationV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VendorBillApplicationV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete a vendor bill application
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return localVarFp.delete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many vendor bill applications
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorBillApplicationFiltersRequestDto} [filters] Query filters for the vendor bill applications
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VendorBillApplicationV1ApiFactory = VendorBillApplicationV1ApiFactory;
/**
 * VendorBillApplicationV1Api - object-oriented interface
 * @export
 * @class VendorBillApplicationV1Api
 * @extends {BaseAPI}
 */
var VendorBillApplicationV1Api = /** @class */ (function (_super) {
    __extends(VendorBillApplicationV1Api, _super);
    function VendorBillApplicationV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete a vendor bill application
     * @param {VendorBillApplicationV1DeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillApplicationV1Api
     */
    VendorBillApplicationV1Api.prototype.delete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillApplicationV1ApiFp)(this.configuration).delete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many vendor bill applications
     * @param {VendorBillApplicationV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillApplicationV1Api
     */
    VendorBillApplicationV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillApplicationV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return VendorBillApplicationV1Api;
}(base_1.BaseAPI));
exports.VendorBillApplicationV1Api = VendorBillApplicationV1Api;
/**
 * VendorBillCreditV1Api - axios parameter creator
 * @export
 */
var VendorBillCreditV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Apply a vendor bill credit
         * @param {string} id
         * @param {ApplyVendorBillCreditRequestDto} applyVendorBillCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyVendorBillCreditRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('apply', 'id', id);
                    // verify required parameter 'applyVendorBillCreditRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('apply', 'applyVendorBillCreditRequestDto', applyVendorBillCreditRequestDto);
                    localVarPath = "/vendor-bill-credit/v1/{id}/apply"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(applyVendorBillCreditRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create a bill credit
         * @param {CreateVendorBillCreditRequestDto} createVendorBillCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorBillCreditRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createVendorBillCreditRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createVendorBillCreditRequestDto', createVendorBillCreditRequestDto);
                    localVarPath = "/vendor-bill-credit/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVendorBillCreditRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a vendor bill credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delete', 'id', id);
                    localVarPath = "/vendor-bill-credit/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a bill credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/vendor-bill-credit/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a vendor bill by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'referenceNumber' is not null or undefined
                    (0, common_1.assertParamExists)('getByReferenceNumber', 'referenceNumber', referenceNumber);
                    localVarPath = "/vendor-bill-credit/v1/reference-number/{referenceNumber}"
                        .replace("{".concat("referenceNumber", "}"), encodeURIComponent(String(referenceNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many vendor bill credits
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorBillCreditsFiltersRequestDto} [filters] Query filters for the vendor bill credits
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill credits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/vendor-bill-credit/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many vendor bill applications
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill credit applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyApplications: function (id, limit, offset, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getManyApplications', 'id', id);
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getManyApplications', 'limit', limit);
                    localVarPath = "/vendor-bill-credit/v1/{id}/applications"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Refresh a bill credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('refresh', 'id', id);
                    localVarPath = "/vendor-bill-credit/v1/{id}/refresh"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Unapply a vendor bill credit application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('unapplyApplication', 'id', id);
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('unapplyApplication', 'applicationId', applicationId);
                    localVarPath = "/vendor-bill-credit/v1/{id}/applications/{applicationId}/unapply"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a bill credit
         * @param {string} id
         * @param {UpdateVendorBillCreditRequestDto} updateVendorBillCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorBillCreditRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'updateVendorBillCreditRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'updateVendorBillCreditRequestDto', updateVendorBillCreditRequestDto);
                    localVarPath = "/vendor-bill-credit/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateVendorBillCreditRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.VendorBillCreditV1ApiAxiosParamCreator = VendorBillCreditV1ApiAxiosParamCreator;
/**
 * VendorBillCreditV1Api - functional programming interface
 * @export
 */
var VendorBillCreditV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VendorBillCreditV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Apply a vendor bill credit
         * @param {string} id
         * @param {ApplyVendorBillCreditRequestDto} applyVendorBillCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyVendorBillCreditRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apply(id, applyVendorBillCreditRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a bill credit
         * @param {CreateVendorBillCreditRequestDto} createVendorBillCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorBillCreditRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createVendorBillCreditRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a vendor bill credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a bill credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a vendor bill by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getByReferenceNumber(referenceNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many vendor bill credits
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorBillCreditsFiltersRequestDto} [filters] Query filters for the vendor bill credits
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill credits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many vendor bill applications
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill credit applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyApplications: function (id, limit, offset, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getManyApplications(id, limit, offset, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Refresh a bill credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refresh(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Unapply a vendor bill credit application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.unapplyApplication(id, applicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a bill credit
         * @param {string} id
         * @param {UpdateVendorBillCreditRequestDto} updateVendorBillCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorBillCreditRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, updateVendorBillCreditRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VendorBillCreditV1ApiFp = VendorBillCreditV1ApiFp;
/**
 * VendorBillCreditV1Api - factory interface
 * @export
 */
var VendorBillCreditV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VendorBillCreditV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Apply a vendor bill credit
         * @param {string} id
         * @param {ApplyVendorBillCreditRequestDto} applyVendorBillCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyVendorBillCreditRequestDto, options) {
            return localVarFp.apply(id, applyVendorBillCreditRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a bill credit
         * @param {CreateVendorBillCreditRequestDto} createVendorBillCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorBillCreditRequestDto, options) {
            return localVarFp.create(createVendorBillCreditRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a vendor bill credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return localVarFp.delete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a bill credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a vendor bill by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return localVarFp.getByReferenceNumber(referenceNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many vendor bill credits
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorBillCreditsFiltersRequestDto} [filters] Query filters for the vendor bill credits
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill credits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many vendor bill applications
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill credit applications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyApplications: function (id, limit, offset, orderBy, options) {
            return localVarFp.getManyApplications(id, limit, offset, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Refresh a bill credit
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return localVarFp.refresh(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Unapply a vendor bill credit application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            return localVarFp.unapplyApplication(id, applicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a bill credit
         * @param {string} id
         * @param {UpdateVendorBillCreditRequestDto} updateVendorBillCreditRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorBillCreditRequestDto, options) {
            return localVarFp.update(id, updateVendorBillCreditRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VendorBillCreditV1ApiFactory = VendorBillCreditV1ApiFactory;
/**
 * VendorBillCreditV1Api - object-oriented interface
 * @export
 * @class VendorBillCreditV1Api
 * @extends {BaseAPI}
 */
var VendorBillCreditV1Api = /** @class */ (function (_super) {
    __extends(VendorBillCreditV1Api, _super);
    function VendorBillCreditV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Apply a vendor bill credit
     * @param {VendorBillCreditV1ApplyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillCreditV1Api
     */
    VendorBillCreditV1Api.prototype.apply = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillCreditV1ApiFp)(this.configuration).apply(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Create a bill credit
     * @param {VendorBillCreditV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillCreditV1Api
     */
    VendorBillCreditV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillCreditV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Delete a vendor bill credit
     * @param {VendorBillCreditV1DeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillCreditV1Api
     */
    VendorBillCreditV1Api.prototype.delete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillCreditV1ApiFp)(this.configuration).delete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a bill credit
     * @param {VendorBillCreditV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillCreditV1Api
     */
    VendorBillCreditV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillCreditV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a vendor bill by reference number
     * @param {VendorBillCreditV1GetByReferenceNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillCreditV1Api
     */
    VendorBillCreditV1Api.prototype.getByReferenceNumber = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillCreditV1ApiFp)(this.configuration).getByReferenceNumber(requestParameters.referenceNumber, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many vendor bill credits
     * @param {VendorBillCreditV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillCreditV1Api
     */
    VendorBillCreditV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillCreditV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many vendor bill applications
     * @param {VendorBillCreditV1GetManyApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillCreditV1Api
     */
    VendorBillCreditV1Api.prototype.getManyApplications = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillCreditV1ApiFp)(this.configuration).getManyApplications(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Refresh a bill credit
     * @param {VendorBillCreditV1RefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillCreditV1Api
     */
    VendorBillCreditV1Api.prototype.refresh = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillCreditV1ApiFp)(this.configuration).refresh(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Unapply a vendor bill credit application
     * @param {VendorBillCreditV1UnapplyApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillCreditV1Api
     */
    VendorBillCreditV1Api.prototype.unapplyApplication = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillCreditV1ApiFp)(this.configuration).unapplyApplication(requestParameters.id, requestParameters.applicationId, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update a bill credit
     * @param {VendorBillCreditV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillCreditV1Api
     */
    VendorBillCreditV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillCreditV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return VendorBillCreditV1Api;
}(base_1.BaseAPI));
exports.VendorBillCreditV1Api = VendorBillCreditV1Api;
/**
 * VendorBillV1Api - axios parameter creator
 * @export
 */
var VendorBillV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get applications for a single vendor bill
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {boolean} [includeUnapplied] Should unapplied applications be included in the response
         * @param {SortOrder} [id2] Order filter for the id
         * @param {SortOrder} [createdAt] Order filter for the createdAt
         * @param {SortOrder} [updated] Order filter for the updatedAt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applications: function (id, limit, offset, includeUnapplied, id2, createdAt, updated, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('applications', 'id', id);
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('applications', 'limit', limit);
                    localVarPath = "/vendor-bill/v1/{id}/applications"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (includeUnapplied !== undefined) {
                        localVarQueryParameter['includeUnapplied'] = includeUnapplied;
                    }
                    if (id2 !== undefined) {
                        localVarQueryParameter['id'] = id2;
                    }
                    if (createdAt !== undefined) {
                        localVarQueryParameter['createdAt'] = createdAt;
                    }
                    if (updated !== undefined) {
                        localVarQueryParameter['updated'] = updated;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create a vendor bill
         * @summary Create a vendor bill
         * @param {CreateVendorBillRequestDto} createVendorBillRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorBillRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createVendorBillRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createVendorBillRequestDto', createVendorBillRequestDto);
                    localVarPath = "/vendor-bill/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVendorBillRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete a vendor bill
         * @summary Delete a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delete', 'id', id);
                    localVarPath = "/vendor-bill/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get a vendor bill
         * @summary Get a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/vendor-bill/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a vendor bill by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'referenceNumber' is not null or undefined
                    (0, common_1.assertParamExists)('getByReferenceNumber', 'referenceNumber', referenceNumber);
                    localVarPath = "/vendor-bill/v1/reference-number/{referenceNumber}"
                        .replace("{".concat("referenceNumber", "}"), encodeURIComponent(String(referenceNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get a vendor bill line items
         * @summary Get a vendor bills line items
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineItems: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getLineItems', 'id', id);
                    localVarPath = "/vendor-bill/v1/{id}/line-items"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many vendor bills
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorBillsFiltersRequestDto} [filters] Query filters for the vendor bills
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/vendor-bill/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get line items for many vendor bills
         * @param {number} limit How many results to return
         * @param {Array<string>} vendorBillIds The vendor bill ids to get the line items for
         * @param {number} [offset] How many results to skip
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill line items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyVendorBillLineItems: function (limit, vendorBillIds, offset, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getManyVendorBillLineItems', 'limit', limit);
                    // verify required parameter 'vendorBillIds' is not null or undefined
                    (0, common_1.assertParamExists)('getManyVendorBillLineItems', 'vendorBillIds', vendorBillIds);
                    localVarPath = "/vendor-bill/v1/many-line-items";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (vendorBillIds) {
                        localVarQueryParameter['vendorBillIds'] = vendorBillIds;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Pays out a vendor bill to the bill\'s vendor using a payment processor and records the payment on the bill. This will error if the bill does not have a vendor assigned.
         * @summary Pay out a vendor bill
         * @param {string} id
         * @param {PayOutVendorBillRequestDto} payOutVendorBillRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payOut: function (id, payOutVendorBillRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('payOut', 'id', id);
                    // verify required parameter 'payOutVendorBillRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('payOut', 'payOutVendorBillRequestDto', payOutVendorBillRequestDto);
                    localVarPath = "/vendor-bill/v1/{id}/pay-out"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(payOutVendorBillRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Refresh a vendor bill
         * @summary Refresh a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('refresh', 'id', id);
                    localVarPath = "/vendor-bill/v1/{id}/refresh"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update a vendor bill
         * @summary Update a vendor bill
         * @param {string} id
         * @param {UpdateVendorBillRequestDto} updateVendorBillRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorBillRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'updateVendorBillRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'updateVendorBillRequestDto', updateVendorBillRequestDto);
                    localVarPath = "/vendor-bill/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateVendorBillRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Void a vendor bill
         * @summary Void a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        void: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('void', 'id', id);
                    localVarPath = "/vendor-bill/v1/{id}/void"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.VendorBillV1ApiAxiosParamCreator = VendorBillV1ApiAxiosParamCreator;
/**
 * VendorBillV1Api - functional programming interface
 * @export
 */
var VendorBillV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VendorBillV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get applications for a single vendor bill
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {boolean} [includeUnapplied] Should unapplied applications be included in the response
         * @param {SortOrder} [id2] Order filter for the id
         * @param {SortOrder} [createdAt] Order filter for the createdAt
         * @param {SortOrder} [updated] Order filter for the updatedAt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applications: function (id, limit, offset, includeUnapplied, id2, createdAt, updated, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.applications(id, limit, offset, includeUnapplied, id2, createdAt, updated, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a vendor bill
         * @summary Create a vendor bill
         * @param {CreateVendorBillRequestDto} createVendorBillRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorBillRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createVendorBillRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete a vendor bill
         * @summary Delete a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a vendor bill
         * @summary Get a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a vendor bill by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getByReferenceNumber(referenceNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get a vendor bill line items
         * @summary Get a vendor bills line items
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineItems: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLineItems(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many vendor bills
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorBillsFiltersRequestDto} [filters] Query filters for the vendor bills
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get line items for many vendor bills
         * @param {number} limit How many results to return
         * @param {Array<string>} vendorBillIds The vendor bill ids to get the line items for
         * @param {number} [offset] How many results to skip
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill line items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyVendorBillLineItems: function (limit, vendorBillIds, offset, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getManyVendorBillLineItems(limit, vendorBillIds, offset, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Pays out a vendor bill to the bill\'s vendor using a payment processor and records the payment on the bill. This will error if the bill does not have a vendor assigned.
         * @summary Pay out a vendor bill
         * @param {string} id
         * @param {PayOutVendorBillRequestDto} payOutVendorBillRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payOut: function (id, payOutVendorBillRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.payOut(id, payOutVendorBillRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Refresh a vendor bill
         * @summary Refresh a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refresh(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update a vendor bill
         * @summary Update a vendor bill
         * @param {string} id
         * @param {UpdateVendorBillRequestDto} updateVendorBillRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorBillRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, updateVendorBillRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Void a vendor bill
         * @summary Void a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        void: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.void(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VendorBillV1ApiFp = VendorBillV1ApiFp;
/**
 * VendorBillV1Api - factory interface
 * @export
 */
var VendorBillV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VendorBillV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Get applications for a single vendor bill
         * @param {string} id
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {boolean} [includeUnapplied] Should unapplied applications be included in the response
         * @param {SortOrder} [id2] Order filter for the id
         * @param {SortOrder} [createdAt] Order filter for the createdAt
         * @param {SortOrder} [updated] Order filter for the updatedAt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applications: function (id, limit, offset, includeUnapplied, id2, createdAt, updated, options) {
            return localVarFp.applications(id, limit, offset, includeUnapplied, id2, createdAt, updated, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a vendor bill
         * @summary Create a vendor bill
         * @param {CreateVendorBillRequestDto} createVendorBillRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorBillRequestDto, options) {
            return localVarFp.create(createVendorBillRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a vendor bill
         * @summary Delete a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return localVarFp.delete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a vendor bill
         * @summary Get a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a vendor bill by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return localVarFp.getByReferenceNumber(referenceNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a vendor bill line items
         * @summary Get a vendor bills line items
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineItems: function (id, options) {
            return localVarFp.getLineItems(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many vendor bills
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorBillsFiltersRequestDto} [filters] Query filters for the vendor bills
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get line items for many vendor bills
         * @param {number} limit How many results to return
         * @param {Array<string>} vendorBillIds The vendor bill ids to get the line items for
         * @param {number} [offset] How many results to skip
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor bill line items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyVendorBillLineItems: function (limit, vendorBillIds, offset, orderBy, options) {
            return localVarFp.getManyVendorBillLineItems(limit, vendorBillIds, offset, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Pays out a vendor bill to the bill\'s vendor using a payment processor and records the payment on the bill. This will error if the bill does not have a vendor assigned.
         * @summary Pay out a vendor bill
         * @param {string} id
         * @param {PayOutVendorBillRequestDto} payOutVendorBillRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payOut: function (id, payOutVendorBillRequestDto, options) {
            return localVarFp.payOut(id, payOutVendorBillRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Refresh a vendor bill
         * @summary Refresh a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return localVarFp.refresh(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a vendor bill
         * @summary Update a vendor bill
         * @param {string} id
         * @param {UpdateVendorBillRequestDto} updateVendorBillRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorBillRequestDto, options) {
            return localVarFp.update(id, updateVendorBillRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Void a vendor bill
         * @summary Void a vendor bill
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        void: function (id, options) {
            return localVarFp.void(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VendorBillV1ApiFactory = VendorBillV1ApiFactory;
/**
 * VendorBillV1Api - object-oriented interface
 * @export
 * @class VendorBillV1Api
 * @extends {BaseAPI}
 */
var VendorBillV1Api = /** @class */ (function (_super) {
    __extends(VendorBillV1Api, _super);
    function VendorBillV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get applications for a single vendor bill
     * @param {VendorBillV1ApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.applications = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).applications(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.includeUnapplied, requestParameters.id2, requestParameters.createdAt, requestParameters.updated, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Create a vendor bill
     * @summary Create a vendor bill
     * @param {VendorBillV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Delete a vendor bill
     * @summary Delete a vendor bill
     * @param {VendorBillV1DeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.delete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).delete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Get a vendor bill
     * @summary Get a vendor bill
     * @param {VendorBillV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a vendor bill by reference number
     * @param {VendorBillV1GetByReferenceNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.getByReferenceNumber = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).getByReferenceNumber(requestParameters.referenceNumber, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Get a vendor bill line items
     * @summary Get a vendor bills line items
     * @param {VendorBillV1GetLineItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.getLineItems = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).getLineItems(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many vendor bills
     * @param {VendorBillV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get line items for many vendor bills
     * @param {VendorBillV1GetManyVendorBillLineItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.getManyVendorBillLineItems = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).getManyVendorBillLineItems(requestParameters.limit, requestParameters.vendorBillIds, requestParameters.offset, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Pays out a vendor bill to the bill\'s vendor using a payment processor and records the payment on the bill. This will error if the bill does not have a vendor assigned.
     * @summary Pay out a vendor bill
     * @param {VendorBillV1PayOutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.payOut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).payOut(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Refresh a vendor bill
     * @summary Refresh a vendor bill
     * @param {VendorBillV1RefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.refresh = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).refresh(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Update a vendor bill
     * @summary Update a vendor bill
     * @param {VendorBillV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     * Void a vendor bill
     * @summary Void a vendor bill
     * @param {VendorBillV1VoidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorBillV1Api
     */
    VendorBillV1Api.prototype.void = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorBillV1ApiFp)(this.configuration).void(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return VendorBillV1Api;
}(base_1.BaseAPI));
exports.VendorBillV1Api = VendorBillV1Api;
/**
 * VendorPaymentV1Api - axios parameter creator
 * @export
 */
var VendorPaymentV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Apply a vendor payment
         * @param {string} id
         * @param {ApplyVendorPaymentRequestDto} applyVendorPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyVendorPaymentRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('apply', 'id', id);
                    // verify required parameter 'applyVendorPaymentRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('apply', 'applyVendorPaymentRequestDto', applyVendorPaymentRequestDto);
                    localVarPath = "/vendor-payment/v1/{id}/apply"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(applyVendorPaymentRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Create a vendor payment
         * @param {CreateVendorPaymentRequestDto} createVendorPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorPaymentRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createVendorPaymentRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createVendorPaymentRequestDto', createVendorPaymentRequestDto);
                    localVarPath = "/vendor-payment/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVendorPaymentRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a vendor payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delete', 'id', id);
                    localVarPath = "/vendor-payment/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a vendor payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/vendor-payment/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a vendor payment by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'referenceNumber' is not null or undefined
                    (0, common_1.assertParamExists)('getByReferenceNumber', 'referenceNumber', referenceNumber);
                    localVarPath = "/vendor-payment/v1/reference-number/{referenceNumber}"
                        .replace("{".concat("referenceNumber", "}"), encodeURIComponent(String(referenceNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get many vendor payments
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorPaymentFiltersRequestDto} [filters] Query filters for vendor payment
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor payments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('getMany', 'limit', limit);
                    localVarPath = "/vendor-payment/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (filters !== undefined) {
                        localVarQueryParameter['filters'] = filters;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Refresh a vendor payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('refresh', 'id', id);
                    localVarPath = "/vendor-payment/v1/{id}/refresh"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Unapply a vendor payment application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('unapplyApplication', 'id', id);
                    // verify required parameter 'applicationId' is not null or undefined
                    (0, common_1.assertParamExists)('unapplyApplication', 'applicationId', applicationId);
                    localVarPath = "/vendor-payment/v1/{id}/applications/{applicationId}/unapply"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a vendor payment
         * @param {string} id
         * @param {UpdateVendorPaymentRequestDto} updateVendorPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorPaymentRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'updateVendorPaymentRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'updateVendorPaymentRequestDto', updateVendorPaymentRequestDto);
                    localVarPath = "/vendor-payment/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateVendorPaymentRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.VendorPaymentV1ApiAxiosParamCreator = VendorPaymentV1ApiAxiosParamCreator;
/**
 * VendorPaymentV1Api - functional programming interface
 * @export
 */
var VendorPaymentV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VendorPaymentV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Apply a vendor payment
         * @param {string} id
         * @param {ApplyVendorPaymentRequestDto} applyVendorPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyVendorPaymentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apply(id, applyVendorPaymentRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a vendor payment
         * @param {CreateVendorPaymentRequestDto} createVendorPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorPaymentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createVendorPaymentRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a vendor payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delete(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a vendor payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a vendor payment by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getByReferenceNumber(referenceNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get many vendor payments
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorPaymentFiltersRequestDto} [filters] Query filters for vendor payment
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor payments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMany(limit, offset, filters, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Refresh a vendor payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refresh(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Unapply a vendor payment application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.unapplyApplication(id, applicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a vendor payment
         * @param {string} id
         * @param {UpdateVendorPaymentRequestDto} updateVendorPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorPaymentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, updateVendorPaymentRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VendorPaymentV1ApiFp = VendorPaymentV1ApiFp;
/**
 * VendorPaymentV1Api - factory interface
 * @export
 */
var VendorPaymentV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VendorPaymentV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Apply a vendor payment
         * @param {string} id
         * @param {ApplyVendorPaymentRequestDto} applyVendorPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: function (id, applyVendorPaymentRequestDto, options) {
            return localVarFp.apply(id, applyVendorPaymentRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a vendor payment
         * @param {CreateVendorPaymentRequestDto} createVendorPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorPaymentRequestDto, options) {
            return localVarFp.create(createVendorPaymentRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a vendor payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete: function (id, options) {
            return localVarFp.delete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a vendor payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a vendor payment by reference number
         * @param {string} referenceNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByReferenceNumber: function (referenceNumber, options) {
            return localVarFp.getByReferenceNumber(referenceNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get many vendor payments
         * @param {number} limit How many results to return
         * @param {number} [offset] How many results to skip
         * @param {GetManyVendorPaymentFiltersRequestDto} [filters] Query filters for vendor payment
         * @param {BaseEntityOrderByDto} [orderBy] Order filters for the vendor payments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMany: function (limit, offset, filters, orderBy, options) {
            return localVarFp.getMany(limit, offset, filters, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Refresh a vendor payment
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return localVarFp.refresh(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Unapply a vendor payment application
         * @param {string} id
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unapplyApplication: function (id, applicationId, options) {
            return localVarFp.unapplyApplication(id, applicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a vendor payment
         * @param {string} id
         * @param {UpdateVendorPaymentRequestDto} updateVendorPaymentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorPaymentRequestDto, options) {
            return localVarFp.update(id, updateVendorPaymentRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VendorPaymentV1ApiFactory = VendorPaymentV1ApiFactory;
/**
 * VendorPaymentV1Api - object-oriented interface
 * @export
 * @class VendorPaymentV1Api
 * @extends {BaseAPI}
 */
var VendorPaymentV1Api = /** @class */ (function (_super) {
    __extends(VendorPaymentV1Api, _super);
    function VendorPaymentV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Apply a vendor payment
     * @param {VendorPaymentV1ApplyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorPaymentV1Api
     */
    VendorPaymentV1Api.prototype.apply = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorPaymentV1ApiFp)(this.configuration).apply(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Create a vendor payment
     * @param {VendorPaymentV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorPaymentV1Api
     */
    VendorPaymentV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorPaymentV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Delete a vendor payment
     * @param {VendorPaymentV1DeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorPaymentV1Api
     */
    VendorPaymentV1Api.prototype.delete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorPaymentV1ApiFp)(this.configuration).delete(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a vendor payment
     * @param {VendorPaymentV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorPaymentV1Api
     */
    VendorPaymentV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorPaymentV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a vendor payment by reference number
     * @param {VendorPaymentV1GetByReferenceNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorPaymentV1Api
     */
    VendorPaymentV1Api.prototype.getByReferenceNumber = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorPaymentV1ApiFp)(this.configuration).getByReferenceNumber(requestParameters.referenceNumber, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get many vendor payments
     * @param {VendorPaymentV1GetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorPaymentV1Api
     */
    VendorPaymentV1Api.prototype.getMany = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorPaymentV1ApiFp)(this.configuration).getMany(requestParameters.limit, requestParameters.offset, requestParameters.filters, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Refresh a vendor payment
     * @param {VendorPaymentV1RefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorPaymentV1Api
     */
    VendorPaymentV1Api.prototype.refresh = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorPaymentV1ApiFp)(this.configuration).refresh(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Unapply a vendor payment application
     * @param {VendorPaymentV1UnapplyApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorPaymentV1Api
     */
    VendorPaymentV1Api.prototype.unapplyApplication = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorPaymentV1ApiFp)(this.configuration).unapplyApplication(requestParameters.id, requestParameters.applicationId, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update a vendor payment
     * @param {VendorPaymentV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorPaymentV1Api
     */
    VendorPaymentV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorPaymentV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return VendorPaymentV1Api;
}(base_1.BaseAPI));
exports.VendorPaymentV1Api = VendorPaymentV1Api;
/**
 * VendorV1Api - axios parameter creator
 * @export
 */
var VendorV1ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a vendor
         * @param {CreateVendorRequestDto} createVendorRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createVendorRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createVendorRequestDto', createVendorRequestDto);
                    localVarPath = "/vendor/v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVendorRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete a vendor
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleted: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleted', 'id', id);
                    localVarPath = "/vendor/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a vendor
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('get', 'id', id);
                    localVarPath = "/vendor/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Refresh a vendor
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('refresh', 'id', id);
                    localVarPath = "/vendor/v1/{id}/refresh"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update a vendor
         * @param {string} id
         * @param {UpdateVendorRequestDto} updateVendorRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'id', id);
                    // verify required parameter 'updateVendorRequestDto' is not null or undefined
                    (0, common_1.assertParamExists)('update', 'updateVendorRequestDto', updateVendorRequestDto);
                    localVarPath = "/vendor/v1/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateVendorRequestDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.VendorV1ApiAxiosParamCreator = VendorV1ApiAxiosParamCreator;
/**
 * VendorV1Api - functional programming interface
 * @export
 */
var VendorV1ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VendorV1ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create a vendor
         * @param {CreateVendorRequestDto} createVendorRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createVendorRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a vendor
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleted: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleted(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a vendor
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.get(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Refresh a vendor
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refresh(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a vendor
         * @param {string} id
         * @param {UpdateVendorRequestDto} updateVendorRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.update(id, updateVendorRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VendorV1ApiFp = VendorV1ApiFp;
/**
 * VendorV1Api - factory interface
 * @export
 */
var VendorV1ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VendorV1ApiFp)(configuration);
    return {
        /**
         *
         * @summary Create a vendor
         * @param {CreateVendorRequestDto} createVendorRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createVendorRequestDto, options) {
            return localVarFp.create(createVendorRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a vendor
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleted: function (id, options) {
            return localVarFp.deleted(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a vendor
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (id, options) {
            return localVarFp.get(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Refresh a vendor
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: function (id, options) {
            return localVarFp.refresh(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a vendor
         * @param {string} id
         * @param {UpdateVendorRequestDto} updateVendorRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: function (id, updateVendorRequestDto, options) {
            return localVarFp.update(id, updateVendorRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VendorV1ApiFactory = VendorV1ApiFactory;
/**
 * VendorV1Api - object-oriented interface
 * @export
 * @class VendorV1Api
 * @extends {BaseAPI}
 */
var VendorV1Api = /** @class */ (function (_super) {
    __extends(VendorV1Api, _super);
    function VendorV1Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a vendor
     * @param {VendorV1CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorV1Api
     */
    VendorV1Api.prototype.create = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorV1ApiFp)(this.configuration).create(requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Delete a vendor
     * @param {VendorV1DeletedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorV1Api
     */
    VendorV1Api.prototype.deleted = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorV1ApiFp)(this.configuration).deleted(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Get a vendor
     * @param {VendorV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorV1Api
     */
    VendorV1Api.prototype.get = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorV1ApiFp)(this.configuration).get(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Refresh a vendor
     * @param {VendorV1RefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorV1Api
     */
    VendorV1Api.prototype.refresh = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorV1ApiFp)(this.configuration).refresh(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    /**
     *
     * @summary Update a vendor
     * @param {VendorV1UpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorV1Api
     */
    VendorV1Api.prototype.update = function (requestParameters, options) {
        var _this = this;
        return (0, exports.VendorV1ApiFp)(this.configuration).update(requestParameters.id, requestParameters.data, options).then(function (request) { return request(_this.axios, _this.basePath); }).then(function (request) { return request.data; });
    };
    return VendorV1Api;
}(base_1.BaseAPI));
exports.VendorV1Api = VendorV1Api;
